export const Learnsets: import('../../../sim/dex-species').ModdedLearnsetDataTable = {
	bulbasaur: {
		learnset: {
			attract: ["3M"],
			bodyslam: ["3T"],
			bulletseed: ["3M"],
			curse: ["3E"],
			cut: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			growl: ["3L4"],
			growth: ["3L32"],
			hiddenpower: ["3M"],
			leechseed: ["3L7"],
			lightscreen: ["3E"],
			magicalleaf: ["3E"],
			mimic: ["3T"],
			petaldance: ["3E"],
			poisonpowder: ["3L15"],
			protect: ["3M"],
			razorleaf: ["3L20"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			safeguard: ["3E"],
			secretpower: ["3M"],
			skullbash: ["3E"],
			sleeppowder: ["3L15"],
			sludgebomb: ["3M"],
			solarbeam: ["3M", "3L46"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			sweetscent: ["3L25"],
			swordsdance: ["3T"],
			synthesis: ["3L39"],
			tackle: ["3L1"],
			toxic: ["3M"],
			vinewhip: ["3L10"],
		},
	},
	ivysaur: {
		learnset: {
			attract: ["3M"],
			bodyslam: ["3T"],
			bulletseed: ["3M"],
			cut: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			growl: ["3L1"],
			growth: ["3L38"],
			hiddenpower: ["3M"],
			leechseed: ["3L1"],
			mimic: ["3T"],
			poisonpowder: ["3L15"],
			protect: ["3M"],
			razorleaf: ["3L22"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			secretpower: ["3M"],
			sleeppowder: ["3L15"],
			sludgebomb: ["3M"],
			solarbeam: ["3M", "3L56"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			sweetscent: ["3L29"],
			swordsdance: ["3T"],
			synthesis: ["3L47"],
			tackle: ["3L1"],
			toxic: ["3M"],
			vinewhip: ["3L10"],
		},
	},
	venusaur: {
		learnset: {
			attract: ["3M"],
			bodyslam: ["3T"],
			bulletseed: ["3M"],
			cut: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			frenzyplant: ["3T"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			growl: ["3L1"],
			growth: ["3L41"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			leechseed: ["3L1"],
			mimic: ["3T"],
			poisonpowder: ["3L15"],
			protect: ["3M"],
			razorleaf: ["3L22"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rocksmash: ["3M"],
			secretpower: ["3M"],
			sleeppowder: ["3L15"],
			sludgebomb: ["3M"],
			solarbeam: ["3M", "3L65"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			sweetscent: ["3L29"],
			swordsdance: ["3T"],
			synthesis: ["3L53"],
			tackle: ["3L1"],
			toxic: ["3M"],
			vinewhip: ["3L1"],
		},
	},
	charmander: {
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			beatup: ["3E"],
			bellydrum: ["3E"],
			bite: ["3E"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			counter: ["3T"],
			cut: ["3M"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dragonclaw: ["3M"],
			dragondance: ["3E"],
			dragonrage: ["3L43"],
			ember: ["3L7"],
			facade: ["3M"],
			fireblast: ["3M"],
			firespin: ["3L49"],
			flamethrower: ["3M", "3L31"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			growl: ["3L1"],
			hiddenpower: ["3M"],
			irontail: ["3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metalclaw: ["3L13"],
			mimic: ["3T"],
			outrage: ["3E"],
			overheat: ["3M"],
			protect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rockslide: ["3T", "3E"],
			rocksmash: ["3M"],
			scaryface: ["3L25"],
			scratch: ["3L1"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			slash: ["3L37"],
			smokescreen: ["3L13"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			swordsdance: ["3T", "3E"],
			toxic: ["3M"],
		},
	},
	charmeleon: {
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			counter: ["3T"],
			cut: ["3M"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dragonclaw: ["3M"],
			dragonrage: ["3L48"],
			ember: ["3L1"],
			facade: ["3M"],
			fireblast: ["3M"],
			firespin: ["3L55"],
			flamethrower: ["3M", "3L34"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			growl: ["3L1"],
			hiddenpower: ["3M"],
			irontail: ["3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metalclaw: ["3L13"],
			mimic: ["3T"],
			overheat: ["3M"],
			protect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rockslide: ["3T"],
			rocksmash: ["3M"],
			scaryface: ["3L27"],
			scratch: ["3L1"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			slash: ["3L41"],
			smokescreen: ["3L13"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			swordsdance: ["3T"],
			toxic: ["3M"],
		},
	},
	charizard: {
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			blastburn: ["3T"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			counter: ["3T"],
			cut: ["3M"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dragonclaw: ["3M"],
			dragonrage: ["3L54"],
			earthquake: ["3M"],
			ember: ["3L1"],
			facade: ["3M"],
			fireblast: ["3M"],
			firespin: ["3L64"],
			flamethrower: ["3M", "3L34"],
			fly: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			growl: ["3L1"],
			heatwave: ["3L1"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			irontail: ["3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metalclaw: ["3L1"],
			mimic: ["3T"],
			overheat: ["3M"],
			protect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rockslide: ["3T"],
			rocksmash: ["3M"],
			scaryface: ["3L27"],
			scratch: ["3L1"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			slash: ["3L44"],
			smokescreen: ["3L1"],
			steelwing: ["3M"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			swordsdance: ["3T"],
			toxic: ["3M"],
			wingattack: ["3L36"],
		},
	},
	squirtle: {
		learnset: {
			attract: ["3M"],
			bite: ["3L18"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			bubble: ["3L7"],
			counter: ["3T"],
			dig: ["3M"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flail: ["3E"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			haze: ["3E"],
			hiddenpower: ["3M"],
			hydropump: ["3L47"],
			icebeam: ["3M"],
			irontail: ["3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mist: ["3E"],
			protect: ["3M", "3L28"],
			raindance: ["3M", "3L33"],
			rapidspin: ["3L23"],
			refresh: ["3E"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			skullbash: ["3L40"],
			strength: ["3M"],
			substitute: ["3T"],
			surf: ["3M"],
			tackle: ["3L1"],
			tailwhip: ["3L4"],
			toxic: ["3M"],
			waterfall: ["3M"],
			watergun: ["3L13"],
			waterpulse: ["3M"],
			withdraw: ["3L10"],
			yawn: ["3E"],
		},
	},
	wartortle: {
		learnset: {
			attract: ["3M"],
			bite: ["3L19"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			bubble: ["3L1"],
			counter: ["3T"],
			dig: ["3M"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hydropump: ["3L53"],
			icebeam: ["3M"],
			irontail: ["3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			protect: ["3M", "3L31"],
			raindance: ["3M", "3L37"],
			rapidspin: ["3L25"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			skullbash: ["3L45"],
			strength: ["3M"],
			substitute: ["3T"],
			surf: ["3M"],
			tackle: ["3L1"],
			tailwhip: ["3L1"],
			toxic: ["3M"],
			waterfall: ["3M"],
			watergun: ["3L13"],
			waterpulse: ["3M"],
			withdraw: ["3L10"],
		},
	},
	blastoise: {
		learnset: {
			attract: ["3M"],
			bite: ["3L19"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			bubble: ["3L1"],
			counter: ["3T"],
			dig: ["3M"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hydrocannon: ["3T"],
			hydropump: ["3L68"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			protect: ["3M", "3L31"],
			raindance: ["3M", "3L42"],
			rapidspin: ["3L25"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rocksmash: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			skullbash: ["3L55"],
			strength: ["3M"],
			substitute: ["3T"],
			surf: ["3M"],
			tackle: ["3L1"],
			tailwhip: ["3L1"],
			toxic: ["3M"],
			waterfall: ["3M"],
			watergun: ["3L13"],
			waterpulse: ["3M"],
			withdraw: ["3L1"],
		},
	},
	caterpie: {
		learnset: {
			stringshot: ["3L1"],
			tackle: ["3L1"],
		},
		encounters: [
			{generation: 3, level: 3},
		],
	},
	metapod: {
		learnset: {
			harden: ["3L1"],
		},
		encounters: [
			{generation: 3, level: 4},
		],
	},
	butterfree: {
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			confusion: ["3L1"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dreameater: ["3T"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			gust: ["3L28"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			mimic: ["3T"],
			poisonpowder: ["3L13"],
			protect: ["3M"],
			psybeam: ["3L34"],
			psychic: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			safeguard: ["3M", "3L40"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			silverwind: ["3L47"],
			skillswap: ["3M"],
			sleeppowder: ["3L15"],
			solarbeam: ["3M"],
			stunspore: ["3L14"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			supersonic: ["3L18"],
			thief: ["3M"],
			toxic: ["3M"],
			whirlwind: ["3L23"],
		},
	},
	weedle: {
		learnset: {
			poisonsting: ["3L1"],
			stringshot: ["3L1"],
		},
		encounters: [
			{generation: 3, level: 3},
		],
	},
	kakuna: {
		learnset: {
			harden: ["3L1"],
		},
		encounters: [
			{generation: 3, level: 4},
		],
	},
	beedrill: {
		learnset: {
			aerialace: ["3M"],
			agility: ["3L40"],
			attract: ["3M"],
			brickbreak: ["3M"],
			cut: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			endeavor: ["3L45"],
			facade: ["3M"],
			focusenergy: ["3L15"],
			frustration: ["3M"],
			furyattack: ["3L1"],
			gigadrain: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			mimic: ["3T"],
			pinmissile: ["3L35"],
			protect: ["3M"],
			pursuit: ["3L30"],
			rage: ["3L25"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			secretpower: ["3M"],
			sludgebomb: ["3M"],
			solarbeam: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			swordsdance: ["3T"],
			thief: ["3M"],
			toxic: ["3M"],
			twineedle: ["3L20"],
		},
	},
	pidgey: {
		learnset: {
			aerialace: ["3M"],
			agility: ["3L39"],
			aircutter: ["3E"],
			attract: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			featherdance: ["3L31"],
			feintattack: ["3E"],
			fly: ["3M"],
			frustration: ["3M"],
			gust: ["3L9"],
			hiddenpower: ["3M"],
			mimic: ["3T"],
			mirrormove: ["3L47"],
			protect: ["3M"],
			pursuit: ["3E"],
			quickattack: ["3L13"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			sandattack: ["3L5"],
			secretpower: ["3M"],
			steelwing: ["3M", "3E"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			tackle: ["3L1"],
			thief: ["3M"],
			toxic: ["3M"],
			whirlwind: ["3L19"],
			wingattack: ["3L25"],
		},
		encounters: [
			{generation: 3, level: 2},
		],
	},
	pidgeotto: {
		learnset: {
			aerialace: ["3M"],
			agility: ["3L43"],
			attract: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			featherdance: ["3L34"],
			fly: ["3M"],
			frustration: ["3M"],
			gust: ["3L1"],
			hiddenpower: ["3M"],
			mimic: ["3T"],
			mirrormove: ["3L52"],
			protect: ["3M"],
			quickattack: ["3L13"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			sandattack: ["3L1"],
			secretpower: ["3M"],
			steelwing: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			tackle: ["3L1"],
			thief: ["3M"],
			toxic: ["3M"],
			whirlwind: ["3L20"],
			wingattack: ["3L27"],
		},
		encounters: [
			{generation: 3, level: 7},
		],
	},
	pidgeot: {
		learnset: {
			aerialace: ["3M"],
			agility: ["3L48"],
			attract: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			featherdance: ["3L34"],
			fly: ["3M"],
			frustration: ["3M"],
			gust: ["3L1"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			mimic: ["3T"],
			mirrormove: ["3L62"],
			protect: ["3M"],
			quickattack: ["3L1"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			sandattack: ["3L1"],
			secretpower: ["3M"],
			steelwing: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			tackle: ["3L1"],
			thief: ["3M"],
			toxic: ["3M"],
			whirlwind: ["3L20"],
			wingattack: ["3L27"],
		},
	},
	rattata: {
		learnset: {
			attract: ["3M"],
			bite: ["3E"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			counter: ["3T", "3E"],
			cut: ["3M"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			endeavor: ["3L41"],
			facade: ["3M"],
			flamewheel: ["3E"],
			focusenergy: ["3L20"],
			frustration: ["3M"],
			furyswipes: ["3E"],
			hiddenpower: ["3M"],
			hyperfang: ["3L13"],
			icebeam: ["3M"],
			irontail: ["3M"],
			mimic: ["3T"],
			protect: ["3M"],
			pursuit: ["3L27"],
			quickattack: ["3L7"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			screech: ["3E"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			superfang: ["3L34"],
			swagger: ["3E"],
			tackle: ["3L1"],
			tailwhip: ["3L1"],
			taunt: ["3M"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			thunderwave: ["3T"],
			toxic: ["3M"],
		},
		encounters: [
			{generation: 3, level: 2},
		],
	},
	raticate: {
		learnset: {
			attract: ["3M"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			counter: ["3T"],
			cut: ["3M"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			endeavor: ["3L50"],
			facade: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			hyperfang: ["3L13"],
			icebeam: ["3M"],
			irontail: ["3M"],
			mimic: ["3T"],
			protect: ["3M"],
			pursuit: ["3L30"],
			quickattack: ["3L1"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rocksmash: ["3M"],
			scaryface: ["3L20"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			superfang: ["3L40"],
			tackle: ["3L1"],
			tailwhip: ["3L1"],
			taunt: ["3M"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			thunderwave: ["3T"],
			toxic: ["3M"],
		},
	},
	spearow: {
		learnset: {
			aerialace: ["3M", "3L25"],
			agility: ["3L43"],
			astonish: ["3E"],
			attract: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			drillpeck: ["3L37"],
			facade: ["3M"],
			falseswipe: ["3E"],
			feintattack: ["3E"],
			fly: ["3M"],
			frustration: ["3M"],
			furyattack: ["3L13"],
			growl: ["3L1"],
			hiddenpower: ["3M"],
			leer: ["3L7"],
			mimic: ["3T"],
			mirrormove: ["3L31"],
			peck: ["3L1"],
			protect: ["3M"],
			pursuit: ["3L19"],
			quickattack: ["3E"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			scaryface: ["3E"],
			secretpower: ["3M"],
			steelwing: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			thief: ["3M"],
			toxic: ["3M"],
			triattack: ["3E"],
		},
		encounters: [
			{generation: 3, level: 3},
		],
	},
	fearow: {
		learnset: {
			aerialace: ["3M"],
			agility: ["3L47"],
			attract: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			drillpeck: ["3L40"],
			facade: ["3M"],
			fly: ["3M"],
			frustration: ["3M"],
			furyattack: ["3L1"],
			growl: ["3L1"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			leer: ["3L1"],
			mimic: ["3T"],
			mirrormove: ["3L32"],
			peck: ["3L1"],
			protect: ["3M"],
			pursuit: ["3L26"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			steelwing: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			thief: ["3M"],
			toxic: ["3M"],
		},
	},
	ekans: {
		learnset: {
			acid: ["3L32"],
			attract: ["3M"],
			beatup: ["3E"],
			bite: ["3L13"],
			bodyslam: ["3T"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			glare: ["3L20"],
			haze: ["3L44"],
			hiddenpower: ["3M"],
			irontail: ["3M"],
			leer: ["3L1"],
			mimic: ["3T"],
			poisonsting: ["3L8"],
			protect: ["3M"],
			pursuit: ["3E"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rockslide: ["3T"],
			screech: ["3L25"],
			secretpower: ["3M"],
			slam: ["3E"],
			sludgebomb: ["3M"],
			snatch: ["3M"],
			spite: ["3E"],
			spitup: ["3L37"],
			stockpile: ["3L37"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			swallow: ["3L37"],
			thief: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
			wrap: ["3L1"],
		},
	},
	arbok: {
		learnset: {
			acid: ["3L38"],
			attract: ["3M"],
			bite: ["3L1"],
			bodyslam: ["3T"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			glare: ["3L20"],
			haze: ["3L56"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			irontail: ["3M"],
			leer: ["3L1"],
			mimic: ["3T"],
			poisonsting: ["3L1"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rockslide: ["3T"],
			screech: ["3L28"],
			secretpower: ["3M"],
			sludgebomb: ["3M"],
			snatch: ["3M"],
			spitup: ["3L46"],
			stockpile: ["3L46"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			swallow: ["3L46"],
			thief: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
			wrap: ["3L1"],
		},
	},
	pichu: {
		learnset: {
			attract: ["3M"],
			bodyslam: ["3T"],
			charm: ["3L1"],
			counter: ["3T"],
			doubleedge: ["3T"],
			doubleslap: ["3E"],
			doubleteam: ["3M"],
			encore: ["3E"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			irontail: ["3M"],
			lightscreen: ["3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			present: ["3E"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			shockwave: ["3M"],
			substitute: ["3T"],
			sweetkiss: ["3L11"],
			tailwhip: ["3L6"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			thundershock: ["3L1"],
			thunderwave: ["3T", "3L8"],
			toxic: ["3M"],
			wish: ["3E"],
		},
	},
	pikachu: {
		learnset: {
			agility: ["3L33"],
			attract: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			counter: ["3T"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M", "3L15"],
			facade: ["3M"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			growl: ["3L1"],
			hiddenpower: ["3M"],
			irontail: ["3M"],
			lightscreen: ["3M", "3L50"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			protect: ["3M"],
			quickattack: ["3L11"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			shockwave: ["3M"],
			slam: ["3L20"],
			strength: ["3M"],
			substitute: ["3T"],
			tailwhip: ["3L6"],
			thunder: ["3M", "3L41"],
			thunderbolt: ["3M", "3L26"],
			thundershock: ["3L1"],
			thunderwave: ["3T", "3L8"],
			toxic: ["3M"],
		},
		encounters: [
			{generation: 3, level: 3},
		],
	},
	raichu: {
		learnset: {
			attract: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			counter: ["3T"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			irontail: ["3M"],
			lightscreen: ["3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			protect: ["3M"],
			quickattack: ["3L1"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			shockwave: ["3M"],
			strength: ["3M"],
			substitute: ["3T"],
			tailwhip: ["3L1"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M", "3L1"],
			thundershock: ["3L1"],
			thunderwave: ["3T"],
			toxic: ["3M"],
		},
	},
	sandshrew: {
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			counter: ["3T", "3E"],
			cut: ["3M"],
			defensecurl: ["3T", "3L6"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			flail: ["3E"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			furyswipes: ["3L37"],
			hiddenpower: ["3M"],
			irontail: ["3M"],
			metalclaw: ["3E"],
			mimic: ["3T"],
			poisonsting: ["3L17"],
			protect: ["3M"],
			rapidspin: ["3E"],
			rest: ["3M"],
			return: ["3M"],
			rockslide: ["3T", "3E"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			safeguard: ["3E"],
			sandattack: ["3L11"],
			sandstorm: ["3M", "3L53"],
			sandtomb: ["3L45"],
			scratch: ["3L1"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			slash: ["3L23"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			swift: ["3T", "3L30"],
			swordsdance: ["3T", "3E"],
			thief: ["3M"],
			toxic: ["3M"],
		},
	},
	sandslash: {
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			counter: ["3T"],
			cut: ["3M"],
			defensecurl: ["3T", "3L1"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			furyswipes: ["3L42"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			irontail: ["3M"],
			mimic: ["3T"],
			poisonsting: ["3L17"],
			protect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rockslide: ["3T"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandattack: ["3L1"],
			sandstorm: ["3M", "3L62"],
			sandtomb: ["3L52"],
			scratch: ["3L1"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			slash: ["3L24"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			swift: ["3T", "3L33"],
			swordsdance: ["3T"],
			thief: ["3M"],
			toxic: ["3M"],
		},
	},
	nidoranf: {
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			beatup: ["3E"],
			bite: ["3L20"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			charm: ["3E"],
			counter: ["3T", "3E"],
			crunch: ["3L47"],
			cut: ["3M"],
			dig: ["3M"],
			disable: ["3E"],
			doubleedge: ["3T"],
			doublekick: ["3L12"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flatter: ["3L38"],
			focusenergy: ["3E"],
			frustration: ["3M"],
			furyswipes: ["3L30"],
			growl: ["3L1"],
			helpinghand: ["3L23"],
			hiddenpower: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			mimic: ["3T"],
			poisonsting: ["3L17"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			scratch: ["3L1"],
			secretpower: ["3M"],
			shockwave: ["3M"],
			sludgebomb: ["3M"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			supersonic: ["3E"],
			tailwhip: ["3L8"],
			takedown: ["3E"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			toxic: ["3M"],
			waterpulse: ["3M"],
		},
	},
	nidorina: {
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			bite: ["3L22"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			counter: ["3T"],
			crunch: ["3L53"],
			cut: ["3M"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doublekick: ["3L12"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flatter: ["3L43"],
			frustration: ["3M"],
			furyswipes: ["3L34"],
			growl: ["3L1"],
			helpinghand: ["3L26"],
			hiddenpower: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			mimic: ["3T"],
			poisonsting: ["3L18"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			scratch: ["3L1"],
			secretpower: ["3M"],
			shockwave: ["3M"],
			sludgebomb: ["3M"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			tailwhip: ["3L8"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			toxic: ["3M"],
			waterpulse: ["3M"],
		},
	},
	nidoqueen: {
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			blizzard: ["3M"],
			bodyslam: ["3T", "3L22"],
			brickbreak: ["3M"],
			counter: ["3T"],
			cut: ["3M"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doublekick: ["3L1"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			poisonsting: ["3L1"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rockslide: ["3T"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandstorm: ["3M"],
			scratch: ["3L1"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			sludgebomb: ["3M"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			superpower: ["3L43"],
			surf: ["3M"],
			tailwhip: ["3L1"],
			taunt: ["3M"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
			waterpulse: ["3M"],
		},
	},
	nidoranm: {
		learnset: {
			amnesia: ["3E"],
			attract: ["3M"],
			beatup: ["3E"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			confusion: ["3E"],
			counter: ["3T", "3E"],
			cut: ["3M"],
			dig: ["3M"],
			disable: ["3E"],
			doubleedge: ["3T"],
			doublekick: ["3L12"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flatter: ["3L38"],
			focusenergy: ["3L8"],
			frustration: ["3M"],
			furyattack: ["3L30"],
			helpinghand: ["3L23"],
			hiddenpower: ["3M"],
			hornattack: ["3L20"],
			horndrill: ["3L47"],
			icebeam: ["3M"],
			irontail: ["3M"],
			leer: ["3L1"],
			mimic: ["3T"],
			peck: ["3L1"],
			poisonsting: ["3L17"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			secretpower: ["3M"],
			shockwave: ["3M"],
			sludgebomb: ["3M"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			supersonic: ["3E"],
			takedown: ["3E"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			toxic: ["3M"],
			waterpulse: ["3M"],
		},
	},
	nidorino: {
		learnset: {
			attract: ["3M"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			counter: ["3T"],
			cut: ["3M"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doublekick: ["3L12"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flatter: ["3L43"],
			focusenergy: ["3L8"],
			frustration: ["3M"],
			furyattack: ["3L34"],
			helpinghand: ["3L26"],
			hiddenpower: ["3M"],
			hornattack: ["3L22"],
			horndrill: ["3L53"],
			icebeam: ["3M"],
			irontail: ["3M"],
			leer: ["3L1"],
			mimic: ["3T"],
			peck: ["3L1"],
			poisonsting: ["3L18"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			secretpower: ["3M"],
			shockwave: ["3M"],
			sludgebomb: ["3M"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			toxic: ["3M"],
			waterpulse: ["3M"],
		},
	},
	nidoking: {
		learnset: {
			attract: ["3M"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			counter: ["3T"],
			cut: ["3M"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doublekick: ["3L1"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			focusenergy: ["3L1"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			megahorn: ["3L43"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			peck: ["3L1"],
			poisonsting: ["3L1"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rockslide: ["3T"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			sludgebomb: ["3M"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			surf: ["3M"],
			taunt: ["3M"],
			thief: ["3M"],
			thrash: ["3L22"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
			waterpulse: ["3M"],
		},
	},
	cleffa: {
		learnset: {
			amnesia: ["3E"],
			attract: ["3M"],
			bellydrum: ["3E"],
			bodyslam: ["3T"],
			charm: ["3L1"],
			counter: ["3T"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dreameater: ["3T"],
			encore: ["3L4"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			irontail: ["3M"],
			lightscreen: ["3M"],
			magicalleaf: ["3L17"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T", "3E"],
			mimic: ["3T", "3E"],
			pound: ["3L1"],
			present: ["3E"],
			protect: ["3M"],
			psychic: ["3M"],
			raindance: ["3M"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			safeguard: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			sing: ["3L8"],
			softboiled: ["3T"],
			solarbeam: ["3M"],
			splash: ["3E"],
			substitute: ["3T", "3E"],
			sunnyday: ["3M"],
			sweetkiss: ["3L13"],
			thunderwave: ["3T"],
			toxic: ["3M"],
			waterpulse: ["3M"],
			wish: ["3E"],
		},
	},
	clefairy: {
		learnset: {
			attract: ["3M"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			calmmind: ["3M"],
			cosmicpower: ["3L33"],
			counter: ["3T"],
			defensecurl: ["3T", "3L25"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleslap: ["3L13"],
			doubleteam: ["3M"],
			dreameater: ["3T"],
			encore: ["3L5"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			flash: ["3M"],
			focuspunch: ["3M"],
			followme: ["3L17"],
			frustration: ["3M"],
			growl: ["3L1"],
			hiddenpower: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			lightscreen: ["3M", "3L41"],
			megakick: ["3T"],
			megapunch: ["3T"],
			meteormash: ["3L45"],
			metronome: ["3T", "3L29"],
			mimic: ["3T"],
			minimize: ["3L21"],
			moonlight: ["3L37"],
			pound: ["3L1"],
			protect: ["3M"],
			psychic: ["3M"],
			raindance: ["3M"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			safeguard: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			sing: ["3L9"],
			snatch: ["3M"],
			softboiled: ["3T"],
			solarbeam: ["3M"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			thunderwave: ["3T"],
			toxic: ["3M"],
			waterpulse: ["3M"],
		},
	},
	clefable: {
		learnset: {
			attract: ["3M"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			calmmind: ["3M"],
			counter: ["3T"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleslap: ["3L1"],
			doubleteam: ["3M"],
			dreameater: ["3T"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			lightscreen: ["3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T", "3L1"],
			mimic: ["3T"],
			minimize: ["3L1"],
			protect: ["3M"],
			psychic: ["3M"],
			raindance: ["3M"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			safeguard: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			sing: ["3L1"],
			snatch: ["3M"],
			softboiled: ["3T"],
			solarbeam: ["3M"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			thunderwave: ["3T"],
			toxic: ["3M"],
			waterpulse: ["3M"],
		},
	},
	vulpix: {
		learnset: {
			attract: ["3M"],
			bodyslam: ["3T"],
			confuseray: ["3L21"],
			dig: ["3M"],
			disable: ["3E"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			ember: ["3L1"],
			facade: ["3M"],
			feintattack: ["3E"],
			fireblast: ["3M"],
			firespin: ["3L41"],
			flail: ["3E"],
			flamethrower: ["3M", "3L29"],
			frustration: ["3M"],
			grudge: ["3L37"],
			hiddenpower: ["3M"],
			hypnosis: ["3E"],
			imprison: ["3L25"],
			irontail: ["3M"],
			mimic: ["3T"],
			overheat: ["3M"],
			protect: ["3M"],
			psychup: ["3E"],
			quickattack: ["3L13"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M", "3L9"],
			safeguard: ["3M", "3L33"],
			secretpower: ["3M"],
			spite: ["3E"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			tailwhip: ["3L5"],
			toxic: ["3M"],
			willowisp: ["3L17"],
		},
	},
	ninetales: {
		learnset: {
			attract: ["3M"],
			bodyslam: ["3T"],
			confuseray: ["3L1"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			ember: ["3L1"],
			facade: ["3M"],
			fireblast: ["3M"],
			firespin: ["3L45"],
			flamethrower: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			irontail: ["3M"],
			mimic: ["3T"],
			overheat: ["3M"],
			protect: ["3M"],
			quickattack: ["3L1"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			safeguard: ["3M", "3L1"],
			secretpower: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			toxic: ["3M"],
		},
	},
	igglybuff: {
		learnset: {
			attract: ["3M"],
			bodyslam: ["3T"],
			charm: ["3L1"],
			counter: ["3T"],
			defensecurl: ["3T", "3L4"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dreameater: ["3T"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			lightscreen: ["3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			perishsong: ["3E"],
			pound: ["3L9"],
			present: ["3E"],
			protect: ["3M"],
			psychic: ["3M"],
			raindance: ["3M"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			safeguard: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			sing: ["3L1"],
			solarbeam: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			sweetkiss: ["3L14"],
			thunderwave: ["3T"],
			toxic: ["3M"],
			waterpulse: ["3M"],
			wish: ["3E"],
		},
	},
	jigglypuff: {
		learnset: {
			attract: ["3M"],
			blizzard: ["3M"],
			bodyslam: ["3T", "3L34"],
			brickbreak: ["3M"],
			counter: ["3T"],
			defensecurl: ["3T", "3L4"],
			dig: ["3M"],
			disable: ["3L14"],
			doubleedge: ["3T", "3L49"],
			doubleslap: ["3L24"],
			doubleteam: ["3M"],
			dreameater: ["3T"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hypervoice: ["3L44"],
			icebeam: ["3M"],
			lightscreen: ["3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T", "3L39"],
			pound: ["3L9"],
			protect: ["3M"],
			psychic: ["3M"],
			raindance: ["3M"],
			reflect: ["3M"],
			rest: ["3M", "3L29"],
			return: ["3M"],
			rollout: ["3T", "3L19"],
			safeguard: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			sing: ["3L1"],
			snatch: ["3M"],
			solarbeam: ["3M"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			thunderwave: ["3T"],
			toxic: ["3M"],
			waterpulse: ["3M"],
		},
		encounters: [
			{generation: 3, level: 3},
		],
	},
	wigglytuff: {
		learnset: {
			attract: ["3M"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			counter: ["3T"],
			defensecurl: ["3T", "3L1"],
			dig: ["3M"],
			disable: ["3L1"],
			doubleedge: ["3T"],
			doubleslap: ["3L1"],
			doubleteam: ["3M"],
			dreameater: ["3T"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			lightscreen: ["3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			protect: ["3M"],
			psychic: ["3M"],
			raindance: ["3M"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			safeguard: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			sing: ["3L1"],
			snatch: ["3M"],
			solarbeam: ["3M"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			thunderwave: ["3T"],
			toxic: ["3M"],
			waterpulse: ["3M"],
		},
	},
	zubat: {
		learnset: {
			aerialace: ["3M"],
			aircutter: ["3L31"],
			astonish: ["3L6"],
			attract: ["3M"],
			bite: ["3L16"],
			confuseray: ["3L26"],
			curse: ["3E"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			feintattack: ["3E"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			gust: ["3E"],
			haze: ["3L46"],
			hiddenpower: ["3M"],
			leechlife: ["3L1"],
			meanlook: ["3L36"],
			mimic: ["3T"],
			poisonfang: ["3L41"],
			protect: ["3M"],
			pursuit: ["3E"],
			quickattack: ["3E"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			sludgebomb: ["3M"],
			snatch: ["3M"],
			steelwing: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			supersonic: ["3L6"],
			taunt: ["3M"],
			thief: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
			whirlwind: ["3E"],
			wingattack: ["3L21"],
		},
	},
	golbat: {
		learnset: {
			aerialace: ["3M"],
			aircutter: ["3L35"],
			astonish: ["3L1"],
			attract: ["3M"],
			bite: ["3L16"],
			confuseray: ["3L28"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			haze: ["3L56"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			leechlife: ["3L1"],
			meanlook: ["3L42"],
			mimic: ["3T"],
			poisonfang: ["3L49"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			screech: ["3L1"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			sludgebomb: ["3M"],
			snatch: ["3M"],
			steelwing: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			supersonic: ["3L1"],
			taunt: ["3M"],
			thief: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
			wingattack: ["3L21"],
		},
		encounters: [
			{generation: 3, level: 5},
		],
	},
	crobat: {
		learnset: {
			aerialace: ["3M"],
			aircutter: ["3L35"],
			astonish: ["3L1"],
			attract: ["3M"],
			bite: ["3L16"],
			confuseray: ["3L28"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			fly: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			haze: ["3L56"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			leechlife: ["3L1"],
			meanlook: ["3L42"],
			mimic: ["3T"],
			poisonfang: ["3L49"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			screech: ["3L1"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			sludgebomb: ["3M"],
			snatch: ["3M"],
			steelwing: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			supersonic: ["3L1"],
			taunt: ["3M"],
			thief: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
			wingattack: ["3L21"],
		},
	},
	oddish: {
		learnset: {
			absorb: ["3L1"],
			acid: ["3L23"],
			attract: ["3M"],
			bulletseed: ["3M"],
			cut: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			hiddenpower: ["3M"],
			ingrain: ["3E"],
			mimic: ["3T"],
			moonlight: ["3L32"],
			petaldance: ["3L39"],
			poisonpowder: ["3L14"],
			protect: ["3M"],
			razorleaf: ["3E"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			sleeppowder: ["3L18"],
			sludgebomb: ["3M"],
			solarbeam: ["3M"],
			stunspore: ["3L16"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			sweetscent: ["3L7"],
			swordsdance: ["3T", "3E"],
			synthesis: ["3E"],
			toxic: ["3M"],
		},
	},
	gloom: {
		learnset: {
			absorb: ["3L1"],
			acid: ["3L24"],
			attract: ["3M"],
			bulletseed: ["3M"],
			cut: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			hiddenpower: ["3M"],
			mimic: ["3T"],
			moonlight: ["3L35"],
			petaldance: ["3L44"],
			poisonpowder: ["3L1"],
			protect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			sleeppowder: ["3L18"],
			sludgebomb: ["3M"],
			solarbeam: ["3M"],
			stunspore: ["3L16"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			sweetscent: ["3L1"],
			swordsdance: ["3T"],
			toxic: ["3M"],
		},
	},
	vileplume: {
		learnset: {
			absorb: ["3L1"],
			aromatherapy: ["3L1"],
			attract: ["3M"],
			bodyslam: ["3T"],
			bulletseed: ["3M"],
			cut: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			megadrain: ["3L1"],
			mimic: ["3T"],
			petaldance: ["3L44"],
			protect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			sludgebomb: ["3M"],
			solarbeam: ["3M"],
			stunspore: ["3L1"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			swordsdance: ["3T"],
			toxic: ["3M"],
		},
	},
	bellossom: {
		learnset: {
			absorb: ["3L1"],
			attract: ["3M"],
			bulletseed: ["3M"],
			cut: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			magicalleaf: ["3L1"],
			mimic: ["3T"],
			petaldance: ["3L44"],
			protect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			safeguard: ["3M"],
			secretpower: ["3M"],
			sludgebomb: ["3M"],
			solarbeam: ["3M", "3L55"],
			stunspore: ["3L1"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			sweetscent: ["3L1"],
			swordsdance: ["3T"],
			toxic: ["3M"],
		},
	},
	paras: {
		learnset: {
			aerialace: ["3M"],
			aromatherapy: ["3L49"],
			attract: ["3M"],
			bodyslam: ["3T"],
			bulletseed: ["3M"],
			counter: ["3T", "3E"],
			cut: ["3M"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			falseswipe: ["3E"],
			flash: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M", "3L43"],
			growth: ["3L37"],
			hiddenpower: ["3M"],
			leechlife: ["3L19"],
			lightscreen: ["3E"],
			mimic: ["3T"],
			poisonpowder: ["3L13"],
			protect: ["3M"],
			psybeam: ["3E"],
			pursuit: ["3E"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			scratch: ["3L1"],
			screech: ["3E"],
			secretpower: ["3M"],
			slash: ["3L31"],
			sludgebomb: ["3M"],
			solarbeam: ["3M"],
			spore: ["3L25"],
			stunspore: ["3L7"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			sweetscent: ["3E"],
			swordsdance: ["3T"],
			thief: ["3M"],
			toxic: ["3M"],
		},
	},
	parasect: {
		learnset: {
			aerialace: ["3M"],
			aromatherapy: ["3L59"],
			attract: ["3M"],
			bodyslam: ["3T"],
			bulletseed: ["3M"],
			counter: ["3T"],
			cut: ["3M"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M", "3L51"],
			growth: ["3L43"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			leechlife: ["3L19"],
			mimic: ["3T"],
			poisonpowder: ["3L1"],
			protect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			scratch: ["3L1"],
			secretpower: ["3M"],
			slash: ["3L35"],
			sludgebomb: ["3M"],
			solarbeam: ["3M"],
			spore: ["3L27"],
			stunspore: ["3L1"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			swordsdance: ["3T"],
			thief: ["3M"],
			toxic: ["3M"],
		},
	},
	venonat: {
		learnset: {
			attract: ["3M"],
			batonpass: ["3E"],
			confusion: ["3L17"],
			disable: ["3L1"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			foresight: ["3L1"],
			frustration: ["3M"],
			gigadrain: ["3M", "3E"],
			hiddenpower: ["3M"],
			leechlife: ["3L25"],
			mimic: ["3T"],
			poisonpowder: ["3L20"],
			protect: ["3M"],
			psybeam: ["3L33"],
			psychic: ["3M", "3L41"],
			rest: ["3M"],
			return: ["3M"],
			screech: ["3E"],
			secretpower: ["3M"],
			skillswap: ["3M"],
			sleeppowder: ["3L36"],
			sludgebomb: ["3M"],
			solarbeam: ["3M"],
			stunspore: ["3L28"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			supersonic: ["3L9"],
			tackle: ["3L1"],
			thief: ["3M"],
			toxic: ["3M"],
		},
	},
	venomoth: {
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			confusion: ["3L17"],
			disable: ["3L1"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			foresight: ["3L1"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			gust: ["3L31"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			leechlife: ["3L25"],
			mimic: ["3T"],
			poisonpowder: ["3L20"],
			protect: ["3M"],
			psybeam: ["3L36"],
			psychic: ["3M", "3L52"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			silverwind: ["3L1"],
			skillswap: ["3M"],
			sleeppowder: ["3L42"],
			sludgebomb: ["3M"],
			solarbeam: ["3M"],
			stunspore: ["3L28"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			supersonic: ["3L1"],
			tackle: ["3L1"],
			thief: ["3M"],
			toxic: ["3M"],
		},
	},
	diglett: {
		learnset: {
			aerialace: ["3M"],
			ancientpower: ["3E"],
			attract: ["3M"],
			beatup: ["3E"],
			bodyslam: ["3T"],
			cut: ["3M"],
			dig: ["3M", "3L17"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			earthquake: ["3M", "3L41"],
			facade: ["3M"],
			feintattack: ["3E"],
			fissure: ["3L49"],
			frustration: ["3M"],
			furyswipes: ["3L21"],
			growl: ["3L5"],
			hiddenpower: ["3M"],
			magnitude: ["3L9"],
			mimic: ["3T"],
			mudslap: ["3T", "3L25"],
			protect: ["3M"],
			pursuit: ["3E"],
			rest: ["3M"],
			return: ["3M"],
			rockslide: ["3T", "3E"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandattack: ["3L1"],
			scratch: ["3L1"],
			screech: ["3E"],
			secretpower: ["3M"],
			slash: ["3L33"],
			sludgebomb: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			thief: ["3M"],
			toxic: ["3M"],
		},
	},
	dugtrio: {
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			bodyslam: ["3T"],
			cut: ["3M"],
			dig: ["3M", "3L17"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			earthquake: ["3M", "3L51"],
			facade: ["3M"],
			fissure: ["3L64"],
			frustration: ["3M"],
			furyswipes: ["3L21"],
			growl: ["3L1"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			magnitude: ["3L9"],
			mimic: ["3T"],
			mudslap: ["3T", "3L25"],
			protect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rockslide: ["3T"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandattack: ["3L1"],
			sandtomb: ["3L26"],
			scratch: ["3L1"],
			secretpower: ["3M"],
			slash: ["3L38"],
			sludgebomb: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			thief: ["3M"],
			toxic: ["3M"],
			triattack: ["3L1"],
		},
	},
	meowth: {
		learnset: {
			aerialace: ["3M"],
			amnesia: ["3E"],
			attract: ["3M"],
			bite: ["3L10"],
			bodyslam: ["3T"],
			charm: ["3E"],
			cut: ["3M"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dreameater: ["3T"],
			facade: ["3M"],
			fakeout: ["3L43"],
			feintattack: ["3L25"],
			flash: ["3M"],
			frustration: ["3M"],
			furyswipes: ["3L36"],
			growl: ["3L1"],
			hiddenpower: ["3M"],
			hypnosis: ["3E"],
			irontail: ["3M"],
			mimic: ["3T"],
			payday: ["3L18"],
			protect: ["3M"],
			psychup: ["3T", "3E"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			scratch: ["3L1"],
			screech: ["3L31"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			slash: ["3L40"],
			snatch: ["3M"],
			spite: ["3E"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			swagger: ["3T", "3L45"],
			taunt: ["3M"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
			waterpulse: ["3M"],
		},
		encounters: [
			{generation: 3, level: 3, gender: "M", nature: "Naive", ivs: {hp: 4, atk: 5, def: 4, spa: 5, spd: 4, spe: 4}, abilities: ["pickup"], pokeball: "pokeball"},
		],
	},
	persian: {
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			bite: ["3L1"],
			bodyslam: ["3T"],
			cut: ["3M"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dreameater: ["3T"],
			facade: ["3M"],
			fakeout: ["3L55"],
			feintattack: ["3L25"],
			flash: ["3M"],
			frustration: ["3M"],
			furyswipes: ["3L42"],
			growl: ["3L1"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			irontail: ["3M"],
			mimic: ["3T"],
			payday: ["3L18"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			scratch: ["3L1"],
			screech: ["3L34"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			slash: ["3L49"],
			snatch: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			swagger: ["3T", "3L61"],
			taunt: ["3M"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
			waterpulse: ["3M"],
		},
	},
	psyduck: {
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			calmmind: ["3M"],
			confusion: ["3L16"],
			counter: ["3T"],
			crosschop: ["3E"],
			dig: ["3M"],
			disable: ["3L10"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			furyswipes: ["3L40"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hydropump: ["3L50"],
			hypnosis: ["3E"],
			icebeam: ["3M"],
			irontail: ["3M"],
			lightscreen: ["3E"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			protect: ["3M"],
			psybeam: ["3E"],
			psychic: ["3E"],
			psychup: ["3T", "3L31"],
			raindance: ["3M"],
			refresh: ["3E"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			scratch: ["3L1"],
			screech: ["3L23"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			strength: ["3M"],
			substitute: ["3T"],
			surf: ["3M"],
			tailwhip: ["3L5"],
			toxic: ["3M"],
			waterfall: ["3M"],
			waterpulse: ["3M"],
			watersport: ["3L1"],
		},
	},
	golduck: {
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			calmmind: ["3M"],
			confusion: ["3L16"],
			counter: ["3T"],
			dig: ["3M"],
			disable: ["3L1"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			furyswipes: ["3L44"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hydropump: ["3L58"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			protect: ["3M"],
			psychup: ["3T", "3L31"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			scratch: ["3L1"],
			screech: ["3L23"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			strength: ["3M"],
			substitute: ["3T"],
			surf: ["3M"],
			tailwhip: ["3L1"],
			toxic: ["3M"],
			waterfall: ["3M"],
			waterpulse: ["3M"],
			watersport: ["3L1"],
		},
		encounters: [
			{generation: 3, level: 25, pokeball: "safariball"},
		],
	},
	mankey: {
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			beatup: ["3E"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			bulkup: ["3M"],
			counter: ["3T", "3E"],
			crosschop: ["3L31"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			focusenergy: ["3L21"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			furyswipes: ["3L16"],
			hiddenpower: ["3M"],
			irontail: ["3M"],
			karatechop: ["3L11"],
			leer: ["3L1"],
			lowkick: ["3L6"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			overheat: ["3M"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rockslide: ["3T", "3E"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			scratch: ["3L1"],
			screech: ["3L41"],
			secretpower: ["3M"],
			seismictoss: ["3T", "3L26"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			swagger: ["3T", "3L36"],
			taunt: ["3M"],
			thief: ["3M"],
			thrash: ["3L46"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			toxic: ["3M"],
		},
		encounters: [
			{generation: 3, level: 2},
		],
	},
	primeape: {
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			bulkup: ["3M"],
			counter: ["3T"],
			crosschop: ["3L35"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			focusenergy: ["3L21"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			furyswipes: ["3L16"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			irontail: ["3M"],
			karatechop: ["3L11"],
			leer: ["3L1"],
			lowkick: ["3L1"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			overheat: ["3M"],
			protect: ["3M"],
			rage: ["3L1"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rockslide: ["3T"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			scratch: ["3L1"],
			screech: ["3L53"],
			secretpower: ["3M"],
			seismictoss: ["3T", "3L26"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			swagger: ["3T", "3L44"],
			taunt: ["3M"],
			thief: ["3M"],
			thrash: ["3L62"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			toxic: ["3M"],
		},
	},
	growlithe: {
		learnset: {
			aerialace: ["3M"],
			agility: ["3L43"],
			attract: ["3M"],
			bite: ["3L1"],
			bodyslam: ["3T", "3E"],
			crunch: ["3E"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			ember: ["3L7"],
			facade: ["3M"],
			fireblast: ["3M"],
			firespin: ["3E"],
			flamethrower: ["3M", "3L49"],
			flamewheel: ["3L31"],
			frustration: ["3M"],
			helpinghand: ["3L37"],
			hiddenpower: ["3M"],
			irontail: ["3M"],
			leer: ["3L13"],
			mimic: ["3T"],
			odorsleuth: ["3L19"],
			overheat: ["3M"],
			protect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M", "3L1"],
			rocksmash: ["3M"],
			safeguard: ["3E"],
			secretpower: ["3M"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			takedown: ["3L25"],
			thief: ["3M"],
			thrash: ["3E"],
			toxic: ["3M"],
		},
	},
	arcanine: {
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			bite: ["3L1"],
			bodyslam: ["3T"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			ember: ["3L1"],
			extremespeed: ["3L49"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			irontail: ["3M"],
			mimic: ["3T"],
			odorsleuth: ["3L1"],
			overheat: ["3M"],
			protect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M", "3L1"],
			rocksmash: ["3M"],
			secretpower: ["3M"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			thief: ["3M"],
			toxic: ["3M"],
		},
	},
	poliwag: {
		learnset: {
			attract: ["3M"],
			bellydrum: ["3L37"],
			blizzard: ["3M"],
			bodyslam: ["3T", "3L31"],
			bubble: ["3L1"],
			bubblebeam: ["3E"],
			dig: ["3M"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleslap: ["3L19"],
			doubleteam: ["3M"],
			facade: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			haze: ["3E"],
			hiddenpower: ["3M"],
			hydropump: ["3L43"],
			hypnosis: ["3L7"],
			icebeam: ["3M"],
			mimic: ["3T"],
			mindreader: ["3E"],
			mist: ["3E"],
			protect: ["3M"],
			psychic: ["3M"],
			raindance: ["3M", "3L25"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			splash: ["3E"],
			substitute: ["3T"],
			surf: ["3M"],
			thief: ["3M"],
			toxic: ["3M"],
			waterfall: ["3M"],
			watergun: ["3L13"],
			waterpulse: ["3M"],
			watersport: ["3E"],
		},
	},
	poliwhirl: {
		learnset: {
			attract: ["3M"],
			bellydrum: ["3L43"],
			blizzard: ["3M"],
			bodyslam: ["3T", "3L35"],
			brickbreak: ["3M"],
			bubble: ["3L1"],
			counter: ["3T"],
			dig: ["3M"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleslap: ["3L19"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hydropump: ["3L51"],
			hypnosis: ["3L1"],
			icebeam: ["3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			protect: ["3M"],
			psychic: ["3M"],
			raindance: ["3M", "3L27"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			strength: ["3M"],
			substitute: ["3T"],
			surf: ["3M"],
			thief: ["3M"],
			toxic: ["3M"],
			waterfall: ["3M"],
			watergun: ["3L1"],
			waterpulse: ["3M"],
		},
		encounters: [
			{generation: 3, level: 20},
		],
	},
	poliwrath: {
		learnset: {
			attract: ["3M"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			bulkup: ["3M"],
			counter: ["3T"],
			dig: ["3M"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleslap: ["3L1"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			hypnosis: ["3L1"],
			icebeam: ["3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mindreader: ["3L51"],
			protect: ["3M"],
			psychic: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			strength: ["3M"],
			submission: ["3L1"],
			substitute: ["3T"],
			surf: ["3M"],
			thief: ["3M"],
			toxic: ["3M"],
			waterfall: ["3M"],
			watergun: ["3L1"],
			waterpulse: ["3M"],
		},
	},
	politoed: {
		learnset: {
			attract: ["3M"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			counter: ["3T"],
			dig: ["3M"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleslap: ["3L1"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			hypnosis: ["3L1"],
			icebeam: ["3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			perishsong: ["3L1"],
			protect: ["3M"],
			psychic: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			strength: ["3M"],
			substitute: ["3T"],
			surf: ["3M"],
			swagger: ["3T", "3L51"],
			thief: ["3M"],
			toxic: ["3M"],
			waterfall: ["3M"],
			watergun: ["3L1"],
			waterpulse: ["3M"],
		},
	},
	abra: {
		learnset: {
			attract: ["3M"],
			barrier: ["3E"],
			bodyslam: ["3T"],
			calmmind: ["3M"],
			counter: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dreameater: ["3T"],
			encore: ["3E"],
			facade: ["3M"],
			firepunch: ["3E"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			icepunch: ["3E"],
			irontail: ["3M"],
			lightscreen: ["3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			protect: ["3M"],
			psychic: ["3M"],
			raindance: ["3M"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			safeguard: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			skillswap: ["3M"],
			snatch: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			taunt: ["3M"],
			teleport: ["3L1"],
			thief: ["3M"],
			thunderpunch: ["3E"],
			thunderwave: ["3T"],
			torment: ["3M"],
			toxic: ["3M"],
		},
	},
	kadabra: {
		learnset: {
			attract: ["3M"],
			bodyslam: ["3T"],
			calmmind: ["3M"],
			confusion: ["3L1"],
			counter: ["3T"],
			disable: ["3L18"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dreameater: ["3T"],
			facade: ["3M"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			futuresight: ["3L30"],
			hiddenpower: ["3M"],
			irontail: ["3M"],
			kinesis: ["3L1"],
			lightscreen: ["3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			protect: ["3M"],
			psybeam: ["3L21"],
			psychic: ["3M", "3L36"],
			raindance: ["3M"],
			recover: ["3L25"],
			reflect: ["3M", "3L23"],
			rest: ["3M"],
			return: ["3M"],
			roleplay: ["3L33"],
			safeguard: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			skillswap: ["3M"],
			snatch: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			taunt: ["3M"],
			teleport: ["3L1"],
			thief: ["3M"],
			thunderwave: ["3T"],
			torment: ["3M"],
			toxic: ["3M"],
			trick: ["3L43"],
		},
	},
	alakazam: {
		learnset: {
			attract: ["3M"],
			bodyslam: ["3T"],
			calmmind: ["3M", "3L33"],
			confusion: ["3L1"],
			counter: ["3T"],
			disable: ["3L18"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dreameater: ["3T"],
			facade: ["3M"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			futuresight: ["3L30"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			irontail: ["3M"],
			kinesis: ["3L1"],
			lightscreen: ["3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			protect: ["3M"],
			psybeam: ["3L21"],
			psychic: ["3M", "3L36"],
			raindance: ["3M"],
			recover: ["3L25"],
			reflect: ["3M", "3L23"],
			rest: ["3M"],
			return: ["3M"],
			safeguard: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			skillswap: ["3M"],
			snatch: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			taunt: ["3M"],
			teleport: ["3L1"],
			thief: ["3M"],
			thunderwave: ["3T"],
			torment: ["3M"],
			toxic: ["3M"],
			trick: ["3L43"],
		},
	},
	machop: {
		learnset: {
			attract: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			bulkup: ["3M"],
			counter: ["3T", "3E"],
			crosschop: ["3L40"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dynamicpunch: ["3T", "3L49"],
			earthquake: ["3M"],
			encore: ["3E"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			focusenergy: ["3L7"],
			focuspunch: ["3M"],
			foresight: ["3L22"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			karatechop: ["3L13"],
			leer: ["3L1"],
			lightscreen: ["3E"],
			lowkick: ["3L1"],
			meditate: ["3E"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			revenge: ["3L25"],
			rockslide: ["3T", "3E"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			rollingkick: ["3E"],
			scaryface: ["3L43"],
			secretpower: ["3M"],
			seismictoss: ["3T", "3L19"],
			strength: ["3M"],
			submission: ["3L37"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			thief: ["3M"],
			toxic: ["3M"],
			vitalthrow: ["3L31"],
		},
	},
	machoke: {
		learnset: {
			attract: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			bulkup: ["3M"],
			counter: ["3T"],
			crosschop: ["3L46"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dynamicpunch: ["3T", "3L59"],
			earthquake: ["3M"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			focusenergy: ["3L1"],
			focuspunch: ["3M"],
			foresight: ["3L22"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			karatechop: ["3L13"],
			leer: ["3L1"],
			lowkick: ["3L1"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			revenge: ["3L25"],
			rockslide: ["3T"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			scaryface: ["3L51"],
			secretpower: ["3M"],
			seismictoss: ["3T", "3L19"],
			strength: ["3M"],
			submission: ["3L41"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			thief: ["3M"],
			toxic: ["3M"],
			vitalthrow: ["3L33"],
		},
	},
	machamp: {
		learnset: {
			attract: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			bulkup: ["3M"],
			counter: ["3T"],
			crosschop: ["3L46"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dynamicpunch: ["3T", "3L59"],
			earthquake: ["3M"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			focusenergy: ["3L1"],
			focuspunch: ["3M"],
			foresight: ["3L22"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			karatechop: ["3L13"],
			leer: ["3L1"],
			lowkick: ["3L1"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			revenge: ["3L25"],
			rockslide: ["3T"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			scaryface: ["3L51"],
			secretpower: ["3M"],
			seismictoss: ["3T", "3L19"],
			strength: ["3M"],
			submission: ["3L41"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			thief: ["3M"],
			toxic: ["3M"],
			vitalthrow: ["3L33"],
		},
	},
	bellsprout: {
		learnset: {
			acid: ["3L23"],
			attract: ["3M"],
			bulletseed: ["3M"],
			cut: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			encore: ["3E"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			growth: ["3L6"],
			hiddenpower: ["3M"],
			ingrain: ["3E"],
			leechlife: ["3E"],
			magicalleaf: ["3E"],
			mimic: ["3T"],
			poisonpowder: ["3L17"],
			protect: ["3M"],
			razorleaf: ["3L37"],
			reflect: ["3E"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			slam: ["3L45"],
			sleeppowder: ["3L15"],
			sludgebomb: ["3M"],
			solarbeam: ["3M"],
			stunspore: ["3L19"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			sweetscent: ["3L30"],
			swordsdance: ["3T", "3E"],
			synthesis: ["3E"],
			thief: ["3M"],
			toxic: ["3M"],
			vinewhip: ["3L1"],
			wrap: ["3L11"],
		},
	},
	weepinbell: {
		learnset: {
			acid: ["3L24"],
			attract: ["3M"],
			bulletseed: ["3M"],
			cut: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			growth: ["3L1"],
			hiddenpower: ["3M"],
			mimic: ["3T"],
			poisonpowder: ["3L17"],
			protect: ["3M"],
			razorleaf: ["3L42"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			slam: ["3L54"],
			sleeppowder: ["3L15"],
			sludgebomb: ["3M"],
			solarbeam: ["3M"],
			stunspore: ["3L19"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			sweetscent: ["3L33"],
			swordsdance: ["3T"],
			thief: ["3M"],
			toxic: ["3M"],
			vinewhip: ["3L1"],
			wrap: ["3L1"],
		},
	},
	victreebel: {
		learnset: {
			attract: ["3M"],
			bodyslam: ["3T"],
			bulletseed: ["3M"],
			cut: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			mimic: ["3T"],
			protect: ["3M"],
			razorleaf: ["3L1"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			sleeppowder: ["3L1"],
			sludgebomb: ["3M"],
			solarbeam: ["3M"],
			spitup: ["3L1"],
			stockpile: ["3L1"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			swallow: ["3L1"],
			sweetscent: ["3L1"],
			swordsdance: ["3T"],
			thief: ["3M"],
			toxic: ["3M"],
			vinewhip: ["3L1"],
		},
	},
	tentacool: {
		learnset: {
			acid: ["3L19"],
			attract: ["3M"],
			aurorabeam: ["3E"],
			barrier: ["3L36"],
			blizzard: ["3M"],
			bubblebeam: ["3L25"],
			confuseray: ["3E"],
			constrict: ["3L12"],
			cut: ["3M"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			hail: ["3M"],
			haze: ["3E"],
			hiddenpower: ["3M"],
			hydropump: ["3L49"],
			icebeam: ["3M"],
			mimic: ["3T"],
			poisonsting: ["3L1"],
			protect: ["3M"],
			raindance: ["3M"],
			rapidspin: ["3E"],
			rest: ["3M"],
			return: ["3M"],
			screech: ["3L43"],
			secretpower: ["3M"],
			sludgebomb: ["3M"],
			substitute: ["3T"],
			supersonic: ["3L6"],
			surf: ["3M"],
			swordsdance: ["3T"],
			thief: ["3M"],
			toxic: ["3M"],
			waterfall: ["3M"],
			waterpulse: ["3M"],
			wrap: ["3L30"],
		},
	},
	tentacruel: {
		learnset: {
			acid: ["3L19"],
			attract: ["3M"],
			barrier: ["3L38"],
			blizzard: ["3M"],
			bubblebeam: ["3L25"],
			constrict: ["3L1"],
			cut: ["3M"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hydropump: ["3L55"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			mimic: ["3T"],
			poisonsting: ["3L1"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			screech: ["3L47"],
			secretpower: ["3M"],
			sludgebomb: ["3M"],
			substitute: ["3T"],
			supersonic: ["3L1"],
			surf: ["3M"],
			swordsdance: ["3T"],
			thief: ["3M"],
			toxic: ["3M"],
			waterfall: ["3M"],
			waterpulse: ["3M"],
			wrap: ["3L30"],
		},
		encounters: [
			{generation: 3, level: 20},
		],
	},
	geodude: {
		learnset: {
			attract: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			counter: ["3T"],
			defensecurl: ["3T", "3L1"],
			dig: ["3M"],
			doubleedge: ["3T", "3L46"],
			doubleteam: ["3M"],
			earthquake: ["3M", "3L36"],
			explosion: ["3T", "3L41"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			magnitude: ["3L16"],
			megapunch: ["3T", "3E"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudsport: ["3L6"],
			protect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rockblast: ["3L31"],
			rockslide: ["3T", "3E"],
			rocksmash: ["3M"],
			rockthrow: ["3L11"],
			rocktomb: ["3M"],
			rollout: ["3T", "3L26"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			selfdestruct: ["3T", "3L21"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			tackle: ["3L1"],
			toxic: ["3M"],
		},
	},
	graveler: {
		learnset: {
			attract: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			counter: ["3T"],
			defensecurl: ["3T", "3L1"],
			dig: ["3M"],
			doubleedge: ["3T", "3L62"],
			doubleteam: ["3M"],
			earthquake: ["3M", "3L45"],
			explosion: ["3T", "3L53"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			magnitude: ["3L16"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudsport: ["3L1"],
			protect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rockblast: ["3L37"],
			rockslide: ["3T"],
			rocksmash: ["3M"],
			rockthrow: ["3L1"],
			rocktomb: ["3M"],
			rollout: ["3T", "3L29"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			selfdestruct: ["3T", "3L21"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			tackle: ["3L1"],
			toxic: ["3M"],
		},
	},
	golem: {
		learnset: {
			attract: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			counter: ["3T"],
			defensecurl: ["3T", "3L1"],
			dig: ["3M"],
			doubleedge: ["3T", "3L62"],
			doubleteam: ["3M"],
			earthquake: ["3M", "3L45"],
			explosion: ["3T", "3L53"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			magnitude: ["3L16"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudsport: ["3L1"],
			protect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rockblast: ["3L37"],
			rockslide: ["3T"],
			rocksmash: ["3M"],
			rockthrow: ["3L1"],
			rocktomb: ["3M"],
			rollout: ["3T", "3L29"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			selfdestruct: ["3T", "3L21"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			tackle: ["3L1"],
			toxic: ["3M"],
		},
	},
	ponyta: {
		learnset: {
			agility: ["3L38"],
			attract: ["3M"],
			bodyslam: ["3T"],
			bounce: ["3L45"],
			charm: ["3E"],
			doubleedge: ["3T", "3E"],
			doublekick: ["3E"],
			doubleteam: ["3M"],
			ember: ["3L14"],
			facade: ["3M"],
			fireblast: ["3M", "3L53"],
			firespin: ["3L25"],
			flamethrower: ["3M"],
			flamewheel: ["3E"],
			frustration: ["3M"],
			growl: ["3L5"],
			hiddenpower: ["3M"],
			hypnosis: ["3E"],
			irontail: ["3M"],
			mimic: ["3T"],
			overheat: ["3M"],
			protect: ["3M"],
			quickattack: ["3L1"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			solarbeam: ["3M"],
			stomp: ["3L19"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			tailwhip: ["3L9"],
			takedown: ["3L31"],
			thrash: ["3E"],
			toxic: ["3M"],
		},
	},
	rapidash: {
		learnset: {
			agility: ["3L38"],
			attract: ["3M"],
			bodyslam: ["3T"],
			bounce: ["3L50"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			ember: ["3L1"],
			facade: ["3M"],
			fireblast: ["3M", "3L63"],
			firespin: ["3L25"],
			flamethrower: ["3M"],
			frustration: ["3M"],
			furyattack: ["3L40"],
			growl: ["3L1"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			irontail: ["3M"],
			mimic: ["3T"],
			overheat: ["3M"],
			protect: ["3M"],
			quickattack: ["3L1"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			solarbeam: ["3M"],
			stomp: ["3L19"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			tailwhip: ["3L1"],
			takedown: ["3L31"],
			toxic: ["3M"],
		},
		encounters: [
			{generation: 3, level: 37},
		],
	},
	slowpoke: {
		learnset: {
			amnesia: ["3L36"],
			attract: ["3M"],
			bellydrum: ["3E"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			calmmind: ["3M"],
			confusion: ["3L17"],
			curse: ["3L1"],
			dig: ["3M"],
			disable: ["3L24"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dreameater: ["3T"],
			earthquake: ["3M"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			growl: ["3L6"],
			hail: ["3M"],
			headbutt: ["3L29"],
			hiddenpower: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			mimic: ["3T"],
			protect: ["3M"],
			psychic: ["3M", "3L40"],
			psychup: ["3T", "3L47"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			safeguard: ["3M", "3E"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			skillswap: ["3M"],
			sleeptalk: ["3T", "3E"],
			snore: ["3T", "3E"],
			stomp: ["3E"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			surf: ["3M"],
			tackle: ["3L1"],
			thunderwave: ["3T"],
			toxic: ["3M"],
			watergun: ["3L13"],
			waterpulse: ["3M"],
			yawn: ["3L1"],
		},
	},
	slowbro: {
		learnset: {
			amnesia: ["3L36"],
			attract: ["3M"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			calmmind: ["3M"],
			confusion: ["3L17"],
			counter: ["3T"],
			curse: ["3L1"],
			dig: ["3M"],
			disable: ["3L24"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dreameater: ["3T"],
			earthquake: ["3M"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			growl: ["3L1"],
			hail: ["3M"],
			headbutt: ["3L29"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			protect: ["3M"],
			psychic: ["3M", "3L44"],
			psychup: ["3T", "3L55"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			safeguard: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			shadowball: ["3M"],
			skillswap: ["3M"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			surf: ["3M"],
			tackle: ["3L1"],
			thunderwave: ["3T"],
			toxic: ["3M"],
			watergun: ["3L13"],
			waterpulse: ["3M"],
			withdraw: ["3L37"],
			yawn: ["3L1"],
		},
		encounters: [
			{generation: 3, level: 32},
		],
	},
	slowking: {
		learnset: {
			attract: ["3M"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			calmmind: ["3M"],
			confusion: ["3L17"],
			counter: ["3T"],
			curse: ["3L1"],
			dig: ["3M"],
			disable: ["3L24"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dreameater: ["3T"],
			earthquake: ["3M"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			growl: ["3L6"],
			hail: ["3M"],
			headbutt: ["3L29"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			protect: ["3M"],
			psychic: ["3M", "3L40"],
			psychup: ["3T", "3L47"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			safeguard: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			shadowball: ["3M"],
			skillswap: ["3M"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			surf: ["3M"],
			swagger: ["3T", "3L36"],
			tackle: ["3L1"],
			thunderwave: ["3T"],
			toxic: ["3M"],
			watergun: ["3L13"],
			waterpulse: ["3M"],
			yawn: ["3L1"],
		},
	},
	magnemite: {
		learnset: {
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			lockon: ["3L32"],
			metalsound: ["3L1"],
			mimic: ["3T"],
			protect: ["3M"],
			raindance: ["3M"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			screech: ["3L44"],
			secretpower: ["3M"],
			shockwave: ["3M"],
			sonicboom: ["3L16"],
			spark: ["3L26"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			supersonic: ["3L11"],
			swift: ["3T", "3L38"],
			tackle: ["3L1"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			thundershock: ["3L6"],
			thunderwave: ["3T", "3L21"],
			toxic: ["3M"],
			zapcannon: ["3L50"],
		},
	},
	magneton: {
		learnset: {
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			lockon: ["3L35"],
			metalsound: ["3L1"],
			mimic: ["3T"],
			protect: ["3M"],
			raindance: ["3M"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			screech: ["3L53"],
			secretpower: ["3M"],
			shockwave: ["3M"],
			sonicboom: ["3L16"],
			spark: ["3L26"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			supersonic: ["3L1"],
			tackle: ["3L1"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			thundershock: ["3L1"],
			thunderwave: ["3T", "3L21"],
			toxic: ["3M"],
			triattack: ["3L44"],
			zapcannon: ["3L62"],
		},
		encounters: [
			{generation: 3, level: 26},
		],
	},
	farfetchd: {
		learnset: {
			aerialace: ["3M"],
			agility: ["3L36"],
			attract: ["3M"],
			bodyslam: ["3T"],
			curse: ["3E"],
			cut: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			falseswipe: ["3L46"],
			featherdance: ["3E"],
			flail: ["3E"],
			fly: ["3M"],
			frustration: ["3M"],
			furyattack: ["3L16"],
			furycutter: ["3L26"],
			gust: ["3E"],
			hiddenpower: ["3M"],
			irontail: ["3M"],
			knockoff: ["3L21"],
			leer: ["3L11"],
			mimic: ["3T"],
			mirrormove: ["3E"],
			peck: ["3L1"],
			protect: ["3M"],
			quickattack: ["3E"],
			rest: ["3M"],
			return: ["3M"],
			sandattack: ["3L6"],
			secretpower: ["3M"],
			slash: ["3L41"],
			steelwing: ["3M", "3E"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			swordsdance: ["3T", "3L31"],
			thief: ["3M"],
			toxic: ["3M"],
		},
		encounters: [
			{generation: 3, level: 3, gender: "M", nature: "Adamant", ivs: {hp: 20, atk: 25, def: 21, spa: 24, spd: 15, spe: 20}, abilities: ["keeneye"], pokeball: "pokeball"},
		],
	},
	doduo: {
		learnset: {
			aerialace: ["3M"],
			agility: ["3L45"],
			attract: ["3M"],
			bodyslam: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			drillpeck: ["3L37"],
			facade: ["3M"],
			feintattack: ["3E"],
			flail: ["3E"],
			fly: ["3M"],
			frustration: ["3M"],
			furyattack: ["3L13"],
			growl: ["3L1"],
			haze: ["3E"],
			hiddenpower: ["3M"],
			mimic: ["3T"],
			peck: ["3L1"],
			protect: ["3M"],
			pursuit: ["3L9"],
			quickattack: ["3E"],
			rage: ["3L25"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			steelwing: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			supersonic: ["3E"],
			thief: ["3M"],
			toxic: ["3M"],
			triattack: ["3L21"],
			uproar: ["3L33"],
		},
	},
	dodrio: {
		learnset: {
			aerialace: ["3M"],
			agility: ["3L60"],
			attract: ["3M"],
			bodyslam: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			drillpeck: ["3L47"],
			facade: ["3M"],
			fly: ["3M"],
			frustration: ["3M"],
			furyattack: ["3L1"],
			growl: ["3L1"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			mimic: ["3T"],
			peck: ["3L1"],
			protect: ["3M"],
			pursuit: ["3L1"],
			rage: ["3L25"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			steelwing: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			taunt: ["3M"],
			thief: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
			triattack: ["3L21"],
			uproar: ["3L38"],
		},
		encounters: [
			{generation: 3, level: 29, pokeball: "safariball"},
		],
	},
	seel: {
		learnset: {
			attract: ["3M"],
			aurorabeam: ["3L21"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			disable: ["3E"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			encore: ["3E"],
			facade: ["3M"],
			fakeout: ["3E"],
			frustration: ["3M"],
			growl: ["3L9"],
			hail: ["3M"],
			headbutt: ["3L1"],
			hiddenpower: ["3M"],
			horndrill: ["3E"],
			icebeam: ["3M", "3L41"],
			icywind: ["3T", "3L17"],
			mimic: ["3T"],
			perishsong: ["3E"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M", "3L29"],
			return: ["3M"],
			safeguard: ["3M", "3L49"],
			secretpower: ["3M"],
			slam: ["3E"],
			substitute: ["3T"],
			surf: ["3M"],
			takedown: ["3L37"],
			thief: ["3M"],
			toxic: ["3M"],
			waterfall: ["3M"],
			waterpulse: ["3M"],
		},
	},
	dewgong: {
		learnset: {
			attract: ["3M"],
			aurorabeam: ["3L1"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			frustration: ["3M"],
			growl: ["3L1"],
			hail: ["3M"],
			headbutt: ["3L1"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M", "3L51"],
			icywind: ["3T", "3L1"],
			mimic: ["3T"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M", "3L29"],
			return: ["3M"],
			safeguard: ["3M", "3L64"],
			secretpower: ["3M"],
			sheercold: ["3L34"],
			signalbeam: ["3L1"],
			substitute: ["3T"],
			surf: ["3M"],
			takedown: ["3L42"],
			thief: ["3M"],
			toxic: ["3M"],
			waterfall: ["3M"],
			waterpulse: ["3M"],
		},
		encounters: [
			{generation: 3, level: 32},
		],
	},
	grimer: {
		learnset: {
			acidarmor: ["3L34"],
			attract: ["3M"],
			bodyslam: ["3T"],
			curse: ["3E"],
			dig: ["3M"],
			disable: ["3L8"],
			doubleteam: ["3M"],
			explosion: ["3T", "3E"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			harden: ["3L4"],
			haze: ["3E"],
			hiddenpower: ["3M"],
			lick: ["3E"],
			meanlook: ["3E"],
			memento: ["3L53"],
			mimic: ["3T"],
			minimize: ["3L19"],
			poisongas: ["3L1"],
			pound: ["3L1"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocktomb: ["3M"],
			screech: ["3L26"],
			secretpower: ["3M"],
			shadowpunch: ["3E"],
			shockwave: ["3M"],
			sludge: ["3L13"],
			sludgebomb: ["3M", "3L43"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			taunt: ["3M"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
		},
	},
	muk: {
		learnset: {
			acidarmor: ["3L34"],
			attract: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			dig: ["3M"],
			disable: ["3L8"],
			doubleteam: ["3M"],
			explosion: ["3T"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			harden: ["3L1"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			memento: ["3L61"],
			mimic: ["3T"],
			minimize: ["3L19"],
			poisongas: ["3L1"],
			pound: ["3L1"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			screech: ["3L26"],
			secretpower: ["3M"],
			shockwave: ["3M"],
			sludge: ["3L13"],
			sludgebomb: ["3M", "3L47"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			taunt: ["3M"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
		},
		encounters: [
			{generation: 3, level: 32},
		],
	},
	shellder: {
		learnset: {
			attract: ["3M"],
			aurorabeam: ["3L17"],
			barrier: ["3E"],
			blizzard: ["3M"],
			bubblebeam: ["3E"],
			clamp: ["3L41"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			explosion: ["3T"],
			facade: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			icebeam: ["3M", "3L49"],
			iciclespear: ["3L8"],
			leer: ["3L33"],
			mimic: ["3T"],
			protect: ["3M", "3L25"],
			raindance: ["3M"],
			rapidspin: ["3E"],
			rest: ["3M"],
			return: ["3M"],
			screech: ["3E"],
			secretpower: ["3M"],
			substitute: ["3T"],
			supersonic: ["3L9"],
			surf: ["3M"],
			tackle: ["3L1"],
			toxic: ["3M"],
			waterpulse: ["3M"],
			withdraw: ["3L1"],
		},
	},
	cloyster: {
		learnset: {
			attract: ["3M"],
			aurorabeam: ["3L1"],
			blizzard: ["3M"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			explosion: ["3T"],
			facade: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			mimic: ["3T"],
			protect: ["3M", "3L1"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			spikecannon: ["3L41"],
			spikes: ["3L33"],
			substitute: ["3T"],
			supersonic: ["3L1"],
			surf: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
			waterpulse: ["3M"],
			withdraw: ["3L1"],
		},
	},
	gastly: {
		learnset: {
			astonish: ["3E"],
			attract: ["3M"],
			confuseray: ["3L21"],
			curse: ["3L13"],
			destinybond: ["3L33"],
			doubleteam: ["3M"],
			dreameater: ["3T", "3L28"],
			explosion: ["3T", "3E"],
			facade: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			grudge: ["3E"],
			haze: ["3E"],
			hiddenpower: ["3M"],
			hypnosis: ["3L1"],
			lick: ["3L1"],
			meanlook: ["3L13"],
			mimic: ["3T"],
			nightmare: ["3T", "3L41"],
			nightshade: ["3L16"],
			perishsong: ["3E"],
			protect: ["3M"],
			psychic: ["3M"],
			psywave: ["3E"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M", "3L36"],
			skillswap: ["3M"],
			sludgebomb: ["3M"],
			snatch: ["3M"],
			spite: ["3L8"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			taunt: ["3M"],
			thief: ["3M"],
			thunderbolt: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
		},
	},
	haunter: {
		learnset: {
			attract: ["3M"],
			confuseray: ["3L21"],
			curse: ["3L13"],
			destinybond: ["3L39"],
			doubleteam: ["3M"],
			dreameater: ["3T", "3L31"],
			explosion: ["3T"],
			facade: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			hiddenpower: ["3M"],
			hypnosis: ["3L1"],
			lick: ["3L1"],
			meanlook: ["3L13"],
			mimic: ["3T"],
			nightmare: ["3T", "3L53"],
			nightshade: ["3L16"],
			protect: ["3M"],
			psychic: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M", "3L45"],
			shadowpunch: ["3L25"],
			skillswap: ["3M"],
			sludgebomb: ["3M"],
			snatch: ["3M"],
			spite: ["3L1"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			taunt: ["3M"],
			thief: ["3M"],
			thunderbolt: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
		},
		encounters: [
			{generation: 3, level: 20},
		],
	},
	gengar: {
		learnset: {
			attract: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			confuseray: ["3L21"],
			counter: ["3T"],
			curse: ["3L13"],
			destinybond: ["3L39"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dreameater: ["3T", "3L31"],
			explosion: ["3T"],
			facade: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			hypnosis: ["3L1"],
			lick: ["3L1"],
			meanlook: ["3L13"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			nightmare: ["3T", "3L53"],
			nightshade: ["3L16"],
			protect: ["3M"],
			psychic: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			shadowball: ["3M", "3L45"],
			shadowpunch: ["3L25"],
			skillswap: ["3M"],
			sludgebomb: ["3M"],
			snatch: ["3M"],
			spite: ["3L1"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			taunt: ["3M"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
		},
	},
	onix: {
		learnset: {
			attract: ["3M"],
			bind: ["3L8"],
			bodyslam: ["3T"],
			dig: ["3M"],
			doubleedge: ["3T", "3L56"],
			doubleteam: ["3M"],
			dragonbreath: ["3L30"],
			earthquake: ["3M"],
			explosion: ["3T", "3E"],
			facade: ["3M"],
			frustration: ["3M"],
			harden: ["3L19"],
			hiddenpower: ["3M"],
			irontail: ["3M", "3L45"],
			mimic: ["3T"],
			protect: ["3M"],
			rage: ["3L23"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rockslide: ["3T", "3E"],
			rocksmash: ["3M"],
			rockthrow: ["3L12"],
			rocktomb: ["3M"],
			sandstorm: ["3M", "3L33"],
			sandtomb: ["3L49"],
			screech: ["3L1"],
			secretpower: ["3M"],
			slam: ["3L37"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			tackle: ["3L1"],
			taunt: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
		},
	},
	steelix: {
		learnset: {
			attract: ["3M"],
			bind: ["3L8"],
			bodyslam: ["3T"],
			crunch: ["3L49"],
			cut: ["3M"],
			dig: ["3M"],
			doubleedge: ["3T", "3L56"],
			doubleteam: ["3M"],
			dragonbreath: ["3L30"],
			earthquake: ["3M"],
			explosion: ["3T"],
			facade: ["3M"],
			frustration: ["3M"],
			harden: ["3L19"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			irontail: ["3M", "3L45"],
			mimic: ["3T"],
			protect: ["3M"],
			rage: ["3L23"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rockslide: ["3T"],
			rocksmash: ["3M"],
			rockthrow: ["3L12"],
			rocktomb: ["3M"],
			sandstorm: ["3M", "3L33"],
			screech: ["3L1"],
			secretpower: ["3M"],
			slam: ["3L37"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			tackle: ["3L1"],
			taunt: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
		},
	},
	drowzee: {
		learnset: {
			attract: ["3M"],
			barrier: ["3E"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			calmmind: ["3M"],
			confusion: ["3L11"],
			counter: ["3T"],
			disable: ["3L7"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dreameater: ["3T"],
			facade: ["3M"],
			firepunch: ["3E"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			futuresight: ["3L45"],
			headbutt: ["3L17"],
			hiddenpower: ["3M"],
			hypnosis: ["3L1"],
			icepunch: ["3E"],
			lightscreen: ["3M"],
			meditate: ["3L27"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			poisongas: ["3L21"],
			pound: ["3L1"],
			protect: ["3M"],
			psychic: ["3M", "3L31"],
			psychup: ["3T", "3L37"],
			raindance: ["3M"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roleplay: ["3E"],
			safeguard: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			shadowball: ["3M"],
			skillswap: ["3M"],
			snatch: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			swagger: ["3T", "3L41"],
			taunt: ["3M"],
			thief: ["3M"],
			thunderpunch: ["3E"],
			thunderwave: ["3T"],
			torment: ["3M"],
			toxic: ["3M"],
		},
	},
	hypno: {
		learnset: {
			attract: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			calmmind: ["3M"],
			confusion: ["3L1"],
			counter: ["3T"],
			disable: ["3L1"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dreameater: ["3T"],
			facade: ["3M"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			futuresight: ["3L57"],
			headbutt: ["3L17"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			hypnosis: ["3L1"],
			lightscreen: ["3M"],
			meditate: ["3L29"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			nightmare: ["3T", "3L1"],
			poisongas: ["3L21"],
			pound: ["3L1"],
			protect: ["3M"],
			psychic: ["3M", "3L35"],
			psychup: ["3T", "3L43"],
			raindance: ["3M"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			safeguard: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			shadowball: ["3M"],
			skillswap: ["3M"],
			snatch: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			swagger: ["3T", "3L49"],
			taunt: ["3M"],
			thief: ["3M"],
			thunderwave: ["3T"],
			torment: ["3M"],
			toxic: ["3M"],
		},
	},
	krabby: {
		learnset: {
			attract: ["3M"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			bubble: ["3L1"],
			crabhammer: ["3L45"],
			cut: ["3M"],
			dig: ["3M", "3E"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flail: ["3L49", "3E"],
			frustration: ["3M"],
			guillotine: ["3L34"],
			hail: ["3M"],
			harden: ["3L16"],
			haze: ["3E"],
			hiddenpower: ["3M"],
			icebeam: ["3M"],
			knockoff: ["3E"],
			leer: ["3L5"],
			mimic: ["3T"],
			mudshot: ["3L23"],
			protect: ["3M", "3L38"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			secretpower: ["3M"],
			slam: ["3E"],
			stomp: ["3L27"],
			strength: ["3M"],
			substitute: ["3T"],
			surf: ["3M"],
			swordsdance: ["3T", "3E"],
			thief: ["3M"],
			toxic: ["3M"],
			visegrip: ["3L12"],
			waterpulse: ["3M"],
		},
	},
	kingler: {
		learnset: {
			attract: ["3M"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			bubble: ["3L1"],
			crabhammer: ["3L57"],
			cut: ["3M"],
			dig: ["3M"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flail: ["3L65"],
			frustration: ["3M"],
			guillotine: ["3L38"],
			hail: ["3M"],
			harden: ["3L1"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			leer: ["3L1"],
			metalclaw: ["3L1"],
			mimic: ["3T"],
			mudshot: ["3L23"],
			protect: ["3M", "3L42"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			secretpower: ["3M"],
			stomp: ["3L27"],
			strength: ["3M"],
			substitute: ["3T"],
			surf: ["3M"],
			swordsdance: ["3T"],
			thief: ["3M"],
			toxic: ["3M"],
			visegrip: ["3L1"],
			waterpulse: ["3M"],
		},
		encounters: [
			{generation: 3, level: 25},
		],
	},
	voltorb: {
		learnset: {
			charge: ["3L1"],
			doubleteam: ["3M"],
			explosion: ["3T", "3L46"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			lightscreen: ["3M", "3L37"],
			mimic: ["3T"],
			mirrorcoat: ["3L49"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rollout: ["3T", "3L32"],
			screech: ["3L8"],
			secretpower: ["3M"],
			selfdestruct: ["3T", "3L27"],
			shockwave: ["3M"],
			sonicboom: ["3L15"],
			spark: ["3L21"],
			substitute: ["3T"],
			swift: ["3T", "3L42"],
			tackle: ["3L1"],
			taunt: ["3M"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			thunderwave: ["3T"],
			torment: ["3M"],
			toxic: ["3M"],
		},
	},
	electrode: {
		learnset: {
			charge: ["3L1"],
			doubleteam: ["3M"],
			explosion: ["3T", "3L54"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			lightscreen: ["3M", "3L41"],
			mimic: ["3T"],
			mirrorcoat: ["3L59"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rollout: ["3T", "3L34"],
			screech: ["3L1"],
			secretpower: ["3M"],
			selfdestruct: ["3T", "3L27"],
			shockwave: ["3M"],
			sonicboom: ["3L1"],
			spark: ["3L21"],
			substitute: ["3T"],
			swift: ["3T", "3L48"],
			tackle: ["3L1"],
			taunt: ["3M"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			thunderwave: ["3T"],
			torment: ["3M"],
			toxic: ["3M"],
		},
		encounters: [
			{generation: 3, level: 3, nature: "Hasty", ivs: {hp: 19, atk: 16, def: 18, spa: 25, spd: 25, spe: 19}, abilities: ["static"], pokeball: "pokeball"},
		],
	},
	exeggcute: {
		learnset: {
			attract: ["3M"],
			barrage: ["3L1"],
			bulletseed: ["3M"],
			confusion: ["3L19"],
			curse: ["3E"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dreameater: ["3T"],
			explosion: ["3T"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			hiddenpower: ["3M"],
			hypnosis: ["3L1"],
			ingrain: ["3E"],
			leechseed: ["3L13"],
			lightscreen: ["3M"],
			mimic: ["3T"],
			moonlight: ["3E"],
			poisonpowder: ["3L31"],
			protect: ["3M"],
			psychic: ["3M"],
			reflect: ["3M", "3L7", "3E"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			skillswap: ["3M"],
			sleeppowder: ["3L37"],
			sludgebomb: ["3M"],
			solarbeam: ["3M", "3L43"],
			strength: ["3M"],
			stunspore: ["3L25"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			synthesis: ["3E"],
			thief: ["3M"],
			toxic: ["3M"],
			uproar: ["3L1"],
		},
	},
	exeggutor: {
		learnset: {
			attract: ["3M"],
			barrage: ["3L1"],
			bulletseed: ["3M"],
			confusion: ["3L1"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dreameater: ["3T"],
			eggbomb: ["3L31"],
			explosion: ["3T"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			hypnosis: ["3L1"],
			lightscreen: ["3M"],
			mimic: ["3T"],
			protect: ["3M"],
			psychic: ["3M"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			skillswap: ["3M"],
			sludgebomb: ["3M"],
			solarbeam: ["3M"],
			stomp: ["3L19"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			thief: ["3M"],
			toxic: ["3M"],
		},
	},
	cubone: {
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			bellydrum: ["3E"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			boneclub: ["3L9"],
			bonemerang: ["3L25"],
			bonerush: ["3L41"],
			brickbreak: ["3M"],
			counter: ["3T"],
			dig: ["3M"],
			doubleedge: ["3T", "3L45"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			falseswipe: ["3L33"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			focusenergy: ["3L21"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			growl: ["3L1"],
			headbutt: ["3L13"],
			hiddenpower: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			leer: ["3L17"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			perishsong: ["3E"],
			protect: ["3M"],
			rage: ["3L29"],
			rest: ["3M"],
			return: ["3M"],
			rockslide: ["3T", "3E"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandstorm: ["3M"],
			screech: ["3E"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			skullbash: ["3E"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			swordsdance: ["3T", "3E"],
			tailwhip: ["3L5"],
			thief: ["3M"],
			thrash: ["3L37"],
			toxic: ["3M"],
		},
	},
	marowak: {
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			boneclub: ["3L1"],
			bonemerang: ["3L25"],
			bonerush: ["3L53"],
			brickbreak: ["3M"],
			counter: ["3T"],
			dig: ["3M"],
			doubleedge: ["3T", "3L61"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			falseswipe: ["3L39"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			focusenergy: ["3L21"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			growl: ["3L1"],
			headbutt: ["3L1"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			leer: ["3L17"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			protect: ["3M"],
			rage: ["3L32"],
			rest: ["3M"],
			return: ["3M"],
			rockslide: ["3T"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			swordsdance: ["3T"],
			tailwhip: ["3L1"],
			thief: ["3M"],
			thrash: ["3L46"],
			toxic: ["3M"],
		},
	},
	tyrogue: {
		learnset: {
			attract: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			bulkup: ["3M"],
			counter: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			highjumpkick: ["3E"],
			machpunch: ["3E"],
			megakick: ["3T"],
			mimic: ["3T"],
			mindreader: ["3E"],
			protect: ["3M"],
			raindance: ["3M"],
			rapidspin: ["3E"],
			rest: ["3M"],
			return: ["3M"],
			rockslide: ["3T"],
			rocksmash: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			tackle: ["3L1"],
			thief: ["3M"],
			toxic: ["3M"],
		},
	},
	hitmonlee: {
		learnset: {
			attract: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M", "3L20"],
			bulkup: ["3M"],
			counter: ["3T"],
			doubleedge: ["3T"],
			doublekick: ["3L1"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			endure: ["3T", "3L41"],
			facade: ["3M"],
			focusenergy: ["3L21"],
			focuspunch: ["3M"],
			foresight: ["3L36"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			highjumpkick: ["3L26"],
			jumpkick: ["3L16"],
			meditate: ["3L6"],
			megakick: ["3T", "3L46"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mindreader: ["3L31"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			revenge: ["3L1"],
			reversal: ["3L51"],
			rockslide: ["3T"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			rollingkick: ["3L11"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			thief: ["3M"],
			toxic: ["3M"],
		},
	},
	hitmonchan: {
		learnset: {
			agility: ["3L7"],
			attract: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			bulkup: ["3M"],
			cometpunch: ["3L1"],
			counter: ["3T", "3L50"],
			detect: ["3L44"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			firepunch: ["3L26"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			icepunch: ["3L26"],
			machpunch: ["3L20"],
			megakick: ["3T"],
			megapunch: ["3T", "3L38"],
			metronome: ["3T"],
			mimic: ["3T"],
			protect: ["3M"],
			pursuit: ["3L13"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			revenge: ["3L1"],
			rockslide: ["3T"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			skyuppercut: ["3L32"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			thief: ["3M"],
			thunderpunch: ["3L26"],
			toxic: ["3M"],
		},
	},
	hitmontop: {
		learnset: {
			agility: ["3L37"],
			attract: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			bulkup: ["3M"],
			counter: ["3T", "3L31"],
			detect: ["3L43"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			endeavor: ["3L49"],
			facade: ["3M"],
			focusenergy: ["3L7"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			megakick: ["3T"],
			mimic: ["3T"],
			protect: ["3M"],
			pursuit: ["3L13"],
			quickattack: ["3L19"],
			raindance: ["3M"],
			rapidspin: ["3L25"],
			rest: ["3M"],
			return: ["3M"],
			revenge: ["3L1"],
			rockslide: ["3T"],
			rocksmash: ["3M"],
			rollingkick: ["3L1"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			thief: ["3M"],
			toxic: ["3M"],
			triplekick: ["3L20"],
		},
	},
	lickitung: {
		learnset: {
			attract: ["3M"],
			bellydrum: ["3E"],
			blizzard: ["3M"],
			bodyslam: ["3T", "3E"],
			brickbreak: ["3M"],
			counter: ["3T"],
			curse: ["3E"],
			cut: ["3M"],
			defensecurl: ["3T", "3L12"],
			dig: ["3M"],
			disable: ["3L34"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dreameater: ["3T"],
			earthquake: ["3M"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			knockoff: ["3L18"],
			lick: ["3L1"],
			magnitude: ["3E"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			protect: ["3M"],
			raindance: ["3M"],
			refresh: ["3L51"],
			rest: ["3M"],
			return: ["3M"],
			rockslide: ["3T"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandstorm: ["3M"],
			screech: ["3L45"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			slam: ["3L40"],
			sleeptalk: ["3E"],
			snore: ["3T", "3E"],
			solarbeam: ["3M"],
			stomp: ["3L23"],
			strength: ["3M"],
			substitute: ["3T", "3E"],
			sunnyday: ["3M"],
			supersonic: ["3L7"],
			surf: ["3M"],
			swordsdance: ["3T"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			toxic: ["3M"],
			waterpulse: ["3M"],
			wrap: ["3L29"],
		},
	},
	koffing: {
		learnset: {
			attract: ["3M"],
			destinybond: ["3L45", "3E"],
			doubleteam: ["3M"],
			explosion: ["3T", "3L41"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			haze: ["3L33"],
			hiddenpower: ["3M"],
			memento: ["3L49"],
			mimic: ["3T"],
			painsplit: ["3E"],
			poisongas: ["3L1"],
			protect: ["3M"],
			psybeam: ["3E"],
			psywave: ["3E"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			screech: ["3E"],
			secretpower: ["3M"],
			selfdestruct: ["3T", "3L17"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			sludge: ["3L21"],
			sludgebomb: ["3M"],
			smog: ["3L9"],
			smokescreen: ["3L25"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			tackle: ["3L1"],
			taunt: ["3M"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
		},
	},
	weezing: {
		learnset: {
			attract: ["3M"],
			destinybond: ["3L51"],
			doubleteam: ["3M"],
			explosion: ["3T", "3L44"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			haze: ["3L33"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			memento: ["3L58"],
			mimic: ["3T"],
			poisongas: ["3L1"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			selfdestruct: ["3T", "3L1"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			sludge: ["3L21"],
			sludgebomb: ["3M"],
			smog: ["3L1"],
			smokescreen: ["3L25"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			tackle: ["3L1"],
			taunt: ["3M"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
		},
		encounters: [
			{generation: 3, level: 32},
		],
	},
	rhyhorn: {
		learnset: {
			attract: ["3M"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			counter: ["3T", "3E"],
			crunch: ["3E"],
			curse: ["3E"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			earthquake: ["3M", "3L52"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			frustration: ["3M"],
			furyattack: ["3L15"],
			hiddenpower: ["3M"],
			hornattack: ["3L1"],
			horndrill: ["3L38"],
			icebeam: ["3M"],
			irontail: ["3M"],
			magnitude: ["3E"],
			megahorn: ["3L57"],
			mimic: ["3T"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rockblast: ["3L29"],
			rockslide: ["3T", "3E"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandstorm: ["3M"],
			scaryface: ["3L24"],
			secretpower: ["3M"],
			shockwave: ["3M"],
			stomp: ["3L10"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			swordsdance: ["3T", "3E"],
			tailwhip: ["3L1"],
			takedown: ["3L43"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			toxic: ["3M"],
		},
	},
	rhydon: {
		learnset: {
			attract: ["3M"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			counter: ["3T"],
			cut: ["3M"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			earthquake: ["3M", "3L58"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			furyattack: ["3L1"],
			hiddenpower: ["3M"],
			hornattack: ["3L1"],
			horndrill: ["3L38"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			megahorn: ["3L66"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rockblast: ["3L29"],
			rockslide: ["3T"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandstorm: ["3M"],
			scaryface: ["3L24"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			shockwave: ["3M"],
			stomp: ["3L1"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			surf: ["3M"],
			swordsdance: ["3T"],
			tailwhip: ["3L1"],
			takedown: ["3L46"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			toxic: ["3M"],
		},
	},
	chansey: {
		learnset: {
			attract: ["3M"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			calmmind: ["3M"],
			counter: ["3T"],
			defensecurl: ["3T", "3L41"],
			doubleedge: ["3T", "3L57"],
			doubleslap: ["3L17"],
			doubleteam: ["3M"],
			dreameater: ["3T"],
			earthquake: ["3M"],
			eggbomb: ["3L35"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			growl: ["3L1"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			lightscreen: ["3M", "3L49"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T", "3E"],
			mimic: ["3T"],
			minimize: ["3L23"],
			pound: ["3L1"],
			present: ["3E"],
			protect: ["3M"],
			psychic: ["3M"],
			raindance: ["3M"],
			refresh: ["3L9"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			safeguard: ["3M"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			sing: ["3L29"],
			skillswap: ["3M"],
			snatch: ["3M"],
			softboiled: ["3T", "3L13"],
			solarbeam: ["3M"],
			strength: ["3M"],
			substitute: ["3T", "3E"],
			sunnyday: ["3M"],
			tailwhip: ["3L5"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			thunderwave: ["3T"],
			toxic: ["3M"],
			waterpulse: ["3M"],
		},
	},
	blissey: {
		learnset: {
			attract: ["3M"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			calmmind: ["3M"],
			counter: ["3T"],
			defensecurl: ["3T", "3L33"],
			doubleedge: ["3T", "3L47"],
			doubleslap: ["3L13"],
			doubleteam: ["3M"],
			dreameater: ["3T"],
			earthquake: ["3M"],
			eggbomb: ["3L28"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			growl: ["3L1"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			lightscreen: ["3M", "3L40"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			minimize: ["3L18"],
			pound: ["3L1"],
			protect: ["3M"],
			psychic: ["3M"],
			raindance: ["3M"],
			refresh: ["3L7"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			safeguard: ["3M"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			sing: ["3L23"],
			skillswap: ["3M"],
			snatch: ["3M"],
			softboiled: ["3T", "3L10"],
			solarbeam: ["3M"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			tailwhip: ["3L4"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			thunderwave: ["3T"],
			toxic: ["3M"],
			waterpulse: ["3M"],
		},
	},
	tangela: {
		learnset: {
			absorb: ["3L10"],
			amnesia: ["3E"],
			attract: ["3M"],
			bind: ["3L28"],
			bodyslam: ["3T"],
			bulletseed: ["3M"],
			confusion: ["3E"],
			constrict: ["3L1"],
			cut: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			growth: ["3L13"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			ingrain: ["3L1"],
			leechseed: ["3E"],
			megadrain: ["3L31", "3E"],
			mimic: ["3T"],
			poisonpowder: ["3L19"],
			protect: ["3M"],
			reflect: ["3E"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			secretpower: ["3M"],
			slam: ["3L40"],
			sleeppowder: ["3L4"],
			sludgebomb: ["3M"],
			solarbeam: ["3M"],
			stunspore: ["3L37"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			swordsdance: ["3T"],
			thief: ["3M"],
			tickle: ["3L46"],
			toxic: ["3M"],
			vinewhip: ["3L22"],
		},
	},
	kangaskhan: {
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			bite: ["3L7"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			cometpunch: ["3L1"],
			counter: ["3T", "3E"],
			cut: ["3M"],
			dig: ["3M"],
			disable: ["3E"],
			dizzypunch: ["3L43"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			endure: ["3T", "3L37"],
			facade: ["3M"],
			fakeout: ["3L19"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			focusenergy: ["3E"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			leer: ["3L1"],
			megakick: ["3T"],
			megapunch: ["3T", "3L25"],
			mimic: ["3T"],
			protect: ["3M"],
			rage: ["3L31"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			reversal: ["3L49"],
			roar: ["3M"],
			rockslide: ["3T"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			safeguard: ["3E"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			solarbeam: ["3M"],
			stomp: ["3E"],
			strength: ["3M"],
			substitute: ["3T", "3E"],
			sunnyday: ["3M"],
			surf: ["3M"],
			tailwhip: ["3L13"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			toxic: ["3M"],
			waterpulse: ["3M"],
		},
	},
	horsea: {
		learnset: {
			agility: ["3L36"],
			attract: ["3M"],
			aurorabeam: ["3E"],
			blizzard: ["3M"],
			bubble: ["3L1"],
			disable: ["3E"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dragondance: ["3L50"],
			dragonrage: ["3E"],
			facade: ["3M"],
			flail: ["3E"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hydropump: ["3L43"],
			icebeam: ["3M"],
			leer: ["3L15"],
			mimic: ["3T"],
			octazooka: ["3E"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			smokescreen: ["3L8"],
			splash: ["3E"],
			substitute: ["3T"],
			surf: ["3M"],
			toxic: ["3M"],
			twister: ["3L29"],
			waterfall: ["3M"],
			watergun: ["3L22"],
			waterpulse: ["3M"],
		},
	},
	seadra: {
		learnset: {
			agility: ["3L40"],
			attract: ["3M"],
			blizzard: ["3M"],
			bubble: ["3L1"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dragondance: ["3L62"],
			facade: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hydropump: ["3L51"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			leer: ["3L1"],
			mimic: ["3T"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			smokescreen: ["3L1"],
			substitute: ["3T"],
			surf: ["3M"],
			toxic: ["3M"],
			twister: ["3L29"],
			waterfall: ["3M"],
			watergun: ["3L1"],
			waterpulse: ["3M"],
		},
		encounters: [
			{generation: 3, level: 25},
		],
	},
	kingdra: {
		learnset: {
			agility: ["3L40"],
			attract: ["3M"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			bubble: ["3L1"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dragondance: ["3L62"],
			facade: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hydropump: ["3L51"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			leer: ["3L1"],
			mimic: ["3T"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			smokescreen: ["3L1"],
			substitute: ["3T"],
			surf: ["3M"],
			toxic: ["3M"],
			twister: ["3L29"],
			waterfall: ["3M"],
			watergun: ["3L1"],
			waterpulse: ["3M"],
		},
	},
	goldeen: {
		learnset: {
			agility: ["3L52"],
			attract: ["3M"],
			blizzard: ["3M"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flail: ["3L24"],
			frustration: ["3M"],
			furyattack: ["3L29"],
			hail: ["3M"],
			haze: ["3E"],
			hiddenpower: ["3M"],
			hornattack: ["3L15"],
			horndrill: ["3L43"],
			hydropump: ["3E"],
			icebeam: ["3M"],
			megahorn: ["3L57"],
			mimic: ["3T"],
			peck: ["3L1"],
			protect: ["3M"],
			psybeam: ["3E"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			substitute: ["3T"],
			supersonic: ["3L10"],
			surf: ["3M"],
			tailwhip: ["3L1"],
			toxic: ["3M"],
			waterfall: ["3M", "3L38"],
			waterpulse: ["3M"],
			watersport: ["3L1"],
		},
	},
	seaking: {
		learnset: {
			agility: ["3L61"],
			attract: ["3M"],
			blizzard: ["3M"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flail: ["3L24"],
			frustration: ["3M"],
			furyattack: ["3L29"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hornattack: ["3L15"],
			horndrill: ["3L49"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			megahorn: ["3L69"],
			mimic: ["3T"],
			peck: ["3L1"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			substitute: ["3T"],
			supersonic: ["3L1"],
			surf: ["3M"],
			tailwhip: ["3L1"],
			toxic: ["3M"],
			waterfall: ["3M", "3L41"],
			waterpulse: ["3M"],
			watersport: ["3L1"],
		},
		encounters: [
			{generation: 3, level: 20},
		],
	},
	staryu: {
		learnset: {
			blizzard: ["3M"],
			bubblebeam: ["3L28"],
			camouflage: ["3L19"],
			cosmicpower: ["3L42"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			harden: ["3L1"],
			hiddenpower: ["3M"],
			hydropump: ["3L46"],
			icebeam: ["3M"],
			lightscreen: ["3M", "3L37"],
			mimic: ["3T"],
			minimize: ["3L33"],
			protect: ["3M"],
			psychic: ["3M"],
			raindance: ["3M"],
			rapidspin: ["3L10"],
			recover: ["3L15"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			substitute: ["3T"],
			surf: ["3M"],
			swift: ["3T", "3L24"],
			tackle: ["3L1"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			thunderwave: ["3T"],
			toxic: ["3M"],
			waterfall: ["3M"],
			watergun: ["3L6"],
			waterpulse: ["3M"],
		},
	},
	starmie: {
		learnset: {
			blizzard: ["3M"],
			confuseray: ["3L33"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dreameater: ["3T"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			lightscreen: ["3M"],
			mimic: ["3T"],
			protect: ["3M"],
			psychic: ["3M"],
			raindance: ["3M"],
			rapidspin: ["3L1"],
			recover: ["3L1"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			skillswap: ["3M"],
			substitute: ["3T"],
			surf: ["3M"],
			swift: ["3T", "3L1"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			thunderwave: ["3T"],
			toxic: ["3M"],
			waterfall: ["3M"],
			watergun: ["3L1"],
			waterpulse: ["3M"],
		},
	},
	mrmime: {
		learnset: {
			attract: ["3M"],
			barrier: ["3L1"],
			batonpass: ["3L47"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			calmmind: ["3M"],
			confusion: ["3L5"],
			counter: ["3T"],
			doubleedge: ["3T"],
			doubleslap: ["3L15"],
			doubleteam: ["3M"],
			dreameater: ["3T"],
			encore: ["3L25"],
			facade: ["3M"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			futuresight: ["3E"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			hypnosis: ["3E"],
			lightscreen: ["3M", "3L19"],
			magicalleaf: ["3L22"],
			meditate: ["3L12"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T", "3E"],
			protect: ["3M"],
			psybeam: ["3L29"],
			psychic: ["3M", "3L43"],
			psychup: ["3T", "3E"],
			raindance: ["3M"],
			recycle: ["3L33"],
			reflect: ["3M", "3L19"],
			rest: ["3M"],
			return: ["3M"],
			roleplay: ["3L40"],
			safeguard: ["3M", "3L50"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			skillswap: ["3M"],
			snatch: ["3M"],
			solarbeam: ["3M"],
			substitute: ["3T", "3L8"],
			sunnyday: ["3M"],
			taunt: ["3M"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			thunderwave: ["3T"],
			torment: ["3M"],
			toxic: ["3M"],
			trick: ["3L36", "3E"],
		},
	},
	scyther: {
		learnset: {
			aerialace: ["3M"],
			agility: ["3L21"],
			attract: ["3M"],
			batonpass: ["3E"],
			counter: ["3T", "3E"],
			cut: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M", "3L41"],
			endure: ["3T", "3E"],
			facade: ["3M"],
			falseswipe: ["3L16"],
			focusenergy: ["3L6"],
			frustration: ["3M"],
			furycutter: ["3T", "3L46"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			leer: ["3L1"],
			lightscreen: ["3E"],
			mimic: ["3T"],
			protect: ["3M"],
			pursuit: ["3L11"],
			quickattack: ["3L1"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			reversal: ["3E"],
			rocksmash: ["3M"],
			safeguard: ["3E"],
			secretpower: ["3M"],
			silverwind: ["3E"],
			slash: ["3L31"],
			steelwing: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			swordsdance: ["3T", "3L36"],
			thief: ["3M"],
			toxic: ["3M"],
			wingattack: ["3L26"],
		},
	},
	scizor: {
		learnset: {
			aerialace: ["3M"],
			agility: ["3L21"],
			attract: ["3M"],
			counter: ["3T"],
			cut: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M", "3L41"],
			facade: ["3M"],
			falseswipe: ["3L16"],
			focusenergy: ["3L6"],
			frustration: ["3M"],
			furycutter: ["3T", "3L46"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			irondefense: ["3L41"],
			leer: ["3L1"],
			metalclaw: ["3L26"],
			mimic: ["3T"],
			protect: ["3M"],
			pursuit: ["3L11"],
			quickattack: ["3L1"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			slash: ["3L31"],
			steelwing: ["3M"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			swordsdance: ["3T", "3L36"],
			thief: ["3M"],
			toxic: ["3M"],
		},
	},
	smoochum: {
		learnset: {
			attract: ["3M"],
			blizzard: ["3M", "3L57"],
			bodyslam: ["3T"],
			calmmind: ["3M"],
			confusion: ["3L21"],
			counter: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dreameater: ["3T"],
			facade: ["3M"],
			faketears: ["3L37"],
			flash: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			icebeam: ["3M"],
			icepunch: ["3E"],
			lick: ["3L1"],
			lightscreen: ["3M"],
			meanlook: ["3L33"],
			meditate: ["3E"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			perishsong: ["3L49"],
			pound: ["3L1"],
			powdersnow: ["3L13"],
			protect: ["3M"],
			psychic: ["3M", "3L45"],
			psychup: ["3T", "3E"],
			raindance: ["3M"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			shadowball: ["3M"],
			sing: ["3L25"],
			skillswap: ["3M"],
			substitute: ["3T"],
			sweetkiss: ["3L9"],
			thief: ["3M"],
			toxic: ["3M"],
			waterpulse: ["3M"],
		},
	},
	jynx: {
		learnset: {
			attract: ["3M"],
			blizzard: ["3M", "3L67"],
			bodyslam: ["3T", "3L51"],
			brickbreak: ["3M"],
			calmmind: ["3M"],
			counter: ["3T"],
			doubleedge: ["3T"],
			doubleslap: ["3L21"],
			doubleteam: ["3M"],
			dreameater: ["3T"],
			facade: ["3M"],
			faketears: ["3L41"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			icepunch: ["3L25"],
			lick: ["3L1"],
			lightscreen: ["3M"],
			lovelykiss: ["3L1"],
			meanlook: ["3L35"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			perishsong: ["3L57"],
			pound: ["3L1"],
			powdersnow: ["3L1"],
			protect: ["3M"],
			psychic: ["3M"],
			raindance: ["3M"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			shadowball: ["3M"],
			skillswap: ["3M"],
			substitute: ["3T"],
			taunt: ["3M"],
			thief: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
			waterpulse: ["3M"],
		},
		encounters: [
			{generation: 3, level: 20, nature: "Mild", ivs: {hp: 18, atk: 17, def: 18, spa: 22, spd: 25, spe: 21}, abilities: ["oblivious"], pokeball: "pokeball"},
		],
	},
	elekid: {
		learnset: {
			attract: ["3M"],
			barrier: ["3E"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			counter: ["3T"],
			crosschop: ["3E"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			firepunch: ["3E"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			icepunch: ["3E"],
			karatechop: ["3E"],
			leer: ["3L1"],
			lightscreen: ["3M", "3L17"],
			meditate: ["3E"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			protect: ["3M"],
			psychic: ["3M"],
			quickattack: ["3L1"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			rollingkick: ["3E"],
			screech: ["3L33"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			shockwave: ["3M"],
			substitute: ["3T"],
			swift: ["3T", "3L25"],
			thief: ["3M"],
			thunder: ["3M", "3L49"],
			thunderbolt: ["3M", "3L41"],
			thunderpunch: ["3L9"],
			thunderwave: ["3T"],
			toxic: ["3M"],
		},
	},
	electabuzz: {
		learnset: {
			attract: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			counter: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			irontail: ["3M"],
			leer: ["3L1"],
			lightscreen: ["3M", "3L17"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			protect: ["3M"],
			psychic: ["3M"],
			quickattack: ["3L1"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			screech: ["3L36"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			shockwave: ["3M"],
			strength: ["3M"],
			substitute: ["3T"],
			swift: ["3T", "3L25"],
			thief: ["3M"],
			thunder: ["3M", "3L58"],
			thunderbolt: ["3M", "3L47"],
			thunderpunch: ["3L1"],
			thunderwave: ["3T"],
			toxic: ["3M"],
		},
	},
	magby: {
		learnset: {
			attract: ["3M"],
			barrier: ["3E"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			confuseray: ["3L43"],
			counter: ["3T"],
			crosschop: ["3E"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			ember: ["3L1"],
			facade: ["3M"],
			fireblast: ["3M", "3L49"],
			firepunch: ["3L19"],
			flamethrower: ["3M", "3L37"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			irontail: ["3M"],
			karatechop: ["3E"],
			leer: ["3L7"],
			megakick: ["3T"],
			megapunch: ["3T", "3E"],
			mimic: ["3T"],
			protect: ["3M"],
			psychic: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			screech: ["3E"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			smog: ["3L13"],
			smokescreen: ["3L25"],
			substitute: ["3T"],
			sunnyday: ["3M", "3L31"],
			thief: ["3M"],
			thunderpunch: ["3E"],
			toxic: ["3M"],
		},
	},
	magmar: {
		learnset: {
			attract: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			confuseray: ["3L49"],
			counter: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			ember: ["3L1"],
			facade: ["3M"],
			fireblast: ["3M", "3L57"],
			firepunch: ["3L1"],
			flamethrower: ["3M", "3L41"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			irontail: ["3M"],
			leer: ["3L1"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			protect: ["3M"],
			psychic: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			smog: ["3L1"],
			smokescreen: ["3L25"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M", "3L33"],
			thief: ["3M"],
			toxic: ["3M"],
		},
	},
	pinsir: {
		learnset: {
			attract: ["3M"],
			bind: ["3L7"],
			bodyslam: ["3T"],
			brickbreak: ["3M", "3L31"],
			bulkup: ["3M"],
			cut: ["3M"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			falseswipe: ["3E"],
			focusenergy: ["3L1"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			furyattack: ["3E"],
			guillotine: ["3L37"],
			harden: ["3L19"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			mimic: ["3T"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			revenge: ["3L25"],
			rockslide: ["3T"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T", "3L13"],
			strength: ["3M"],
			submission: ["3L43"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			swordsdance: ["3T", "3L49"],
			thief: ["3M"],
			toxic: ["3M"],
			visegrip: ["3L1"],
		},
	},
	tauros: {
		learnset: {
			attract: ["3M"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hornattack: ["3L8"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			mimic: ["3T"],
			protect: ["3M"],
			pursuit: ["3L19"],
			rage: ["3L4"],
			raindance: ["3M"],
			rest: ["3M", "3L34"],
			return: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandstorm: ["3M"],
			scaryface: ["3L13"],
			secretpower: ["3M"],
			shockwave: ["3M"],
			solarbeam: ["3M"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			surf: ["3M"],
			swagger: ["3T", "3L26"],
			tackle: ["3L1"],
			tailwhip: ["3L1"],
			takedown: ["3L53"],
			thrash: ["3L43"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			toxic: ["3M"],
			waterpulse: ["3M"],
		},
	},
	magikarp: {
		learnset: {
			flail: ["3L30"],
			splash: ["3L1"],
			tackle: ["3L15"],
		},
	},
	gyarados: {
		learnset: {
			attract: ["3M"],
			bite: ["3L20"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dragondance: ["3L50"],
			dragonrage: ["3L25"],
			earthquake: ["3M"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hydropump: ["3L40"],
			hyperbeam: ["3M", "3L55"],
			icebeam: ["3M"],
			leer: ["3L30"],
			mimic: ["3T"],
			protect: ["3M"],
			raindance: ["3M", "3L45"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rocksmash: ["3M"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			strength: ["3M"],
			substitute: ["3T"],
			surf: ["3M"],
			taunt: ["3M"],
			thrash: ["3L1"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			thunderwave: ["3T"],
			torment: ["3M"],
			toxic: ["3M"],
			twister: ["3L35"],
			waterfall: ["3M"],
			waterpulse: ["3M"],
		},
		encounters: [
			{generation: 3, level: 5},
		],
	},
	lapras: {
		learnset: {
			attract: ["3M"],
			blizzard: ["3M"],
			bodyslam: ["3T", "3L13"],
			confuseray: ["3L19"],
			curse: ["3E"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dragondance: ["3E"],
			dreameater: ["3T"],
			facade: ["3M"],
			frustration: ["3M"],
			growl: ["3L1"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			horndrill: ["3E"],
			hydropump: ["3L49"],
			hyperbeam: ["3M"],
			icebeam: ["3M", "3L31"],
			irontail: ["3M"],
			mimic: ["3T"],
			mist: ["3L7"],
			perishsong: ["3L25"],
			protect: ["3M"],
			psychic: ["3M"],
			raindance: ["3M", "3L37"],
			refresh: ["3E"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rocksmash: ["3M"],
			safeguard: ["3M", "3L43"],
			secretpower: ["3M"],
			sheercold: ["3L55"],
			shockwave: ["3M"],
			sing: ["3L1"],
			sleeptalk: ["3T", "3E"],
			strength: ["3M"],
			substitute: ["3T", "3E"],
			surf: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			tickle: ["3E"],
			toxic: ["3M"],
			waterfall: ["3M"],
			watergun: ["3L1"],
			waterpulse: ["3M"],
		},
	},
	ditto: {
		learnset: {
			transform: ["3L1"],
		},
		encounters: [
			{generation: 3, level: 23},
		],
	},
	eevee: {
		learnset: {
			attract: ["3M"],
			batonpass: ["3L36"],
			bite: ["3L30"],
			bodyslam: ["3T"],
			charm: ["3E"],
			curse: ["3E"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			endure: ["3T", "3E"],
			facade: ["3M"],
			flail: ["3E"],
			frustration: ["3M"],
			growl: ["3L16"],
			helpinghand: ["3L1"],
			hiddenpower: ["3M"],
			irontail: ["3M"],
			mimic: ["3T"],
			protect: ["3M"],
			quickattack: ["3L23"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			sandattack: ["3L8"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			tackle: ["3L1"],
			tailwhip: ["3L1"],
			takedown: ["3L42"],
			toxic: ["3M"],
			wish: ["3E"],
		},
	},
	vaporeon: {
		learnset: {
			acidarmor: ["3L47"],
			attract: ["3M"],
			aurorabeam: ["3L36"],
			bite: ["3L30"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			dig: ["3M"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			haze: ["3L42"],
			helpinghand: ["3L1"],
			hiddenpower: ["3M"],
			hydropump: ["3L52"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			mimic: ["3T"],
			protect: ["3M"],
			quickattack: ["3L23"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			sandattack: ["3L8"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			surf: ["3M"],
			tackle: ["3L1"],
			tailwhip: ["3L1"],
			toxic: ["3M"],
			waterfall: ["3M"],
			watergun: ["3L16"],
			waterpulse: ["3M"],
		},
	},
	jolteon: {
		learnset: {
			agility: ["3L47"],
			attract: ["3M"],
			bodyslam: ["3T"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doublekick: ["3L30"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			helpinghand: ["3L1"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			irontail: ["3M"],
			mimic: ["3T"],
			pinmissile: ["3L36"],
			protect: ["3M"],
			quickattack: ["3L23"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			sandattack: ["3L8"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			tackle: ["3L1"],
			tailwhip: ["3L1"],
			thunder: ["3M", "3L52"],
			thunderbolt: ["3M"],
			thundershock: ["3L16"],
			thunderwave: ["3T", "3L42"],
			toxic: ["3M"],
		},
	},
	flareon: {
		learnset: {
			attract: ["3M"],
			bite: ["3L30"],
			bodyslam: ["3T"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			ember: ["3L16"],
			facade: ["3M"],
			fireblast: ["3M"],
			firespin: ["3L36"],
			flamethrower: ["3M", "3L52"],
			frustration: ["3M"],
			helpinghand: ["3L1"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			irontail: ["3M"],
			leer: ["3L47"],
			mimic: ["3T"],
			overheat: ["3M"],
			protect: ["3M"],
			quickattack: ["3L23"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			sandattack: ["3L8"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			smog: ["3L42"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			tackle: ["3L1"],
			tailwhip: ["3L1"],
			toxic: ["3M"],
		},
	},
	porygon: {
		learnset: {
			aerialace: ["3M"],
			agility: ["3L9"],
			blizzard: ["3M"],
			conversion: ["3L1"],
			conversion2: ["3L1"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dreameater: ["3T"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			lockon: ["3L32"],
			mimic: ["3T"],
			protect: ["3M"],
			psybeam: ["3L12"],
			psychic: ["3M"],
			raindance: ["3M"],
			recover: ["3L20"],
			recycle: ["3L44"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			sharpen: ["3L24"],
			shockwave: ["3M"],
			solarbeam: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			tackle: ["3L1"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			thunderwave: ["3T"],
			toxic: ["3M"],
			triattack: ["3L36"],
			zapcannon: ["3L48"],
		},
	},
	porygon2: {
		learnset: {
			aerialace: ["3M"],
			agility: ["3L9"],
			blizzard: ["3M"],
			conversion: ["3L1"],
			conversion2: ["3L1"],
			defensecurl: ["3T", "3L24"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dreameater: ["3T"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			lockon: ["3L32"],
			mimic: ["3T"],
			protect: ["3M"],
			psybeam: ["3L12"],
			psychic: ["3M"],
			raindance: ["3M"],
			recover: ["3L20"],
			recycle: ["3L44"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			solarbeam: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			tackle: ["3L1"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			thunderwave: ["3T"],
			toxic: ["3M"],
			triattack: ["3L36"],
			zapcannon: ["3L48"],
		},
	},
	omanyte: {
		learnset: {
			ancientpower: ["3L49"],
			attract: ["3M"],
			aurorabeam: ["3E"],
			bite: ["3L13"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			bubblebeam: ["3E"],
			constrict: ["3L1"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			haze: ["3E"],
			hiddenpower: ["3M"],
			hydropump: ["3L55"],
			icebeam: ["3M"],
			leer: ["3L31"],
			mimic: ["3T"],
			mudshot: ["3L25"],
			protect: ["3M", "3L37"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rockslide: ["3T", "3E"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			slam: ["3E"],
			spikes: ["3E"],
			substitute: ["3T"],
			supersonic: ["3E"],
			surf: ["3M"],
			thief: ["3M"],
			tickle: ["3L43"],
			toxic: ["3M"],
			waterfall: ["3M"],
			watergun: ["3L19"],
			waterpulse: ["3M"],
			withdraw: ["3L1"],
		},
	},
	omastar: {
		learnset: {
			ancientpower: ["3L55"],
			attract: ["3M"],
			bite: ["3L1"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			constrict: ["3L1"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hydropump: ["3L65"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			leer: ["3L31"],
			mimic: ["3T"],
			mudshot: ["3L25"],
			protect: ["3M", "3L37"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rockslide: ["3T"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			spikecannon: ["3L40"],
			substitute: ["3T"],
			surf: ["3M"],
			thief: ["3M"],
			tickle: ["3L46"],
			toxic: ["3M"],
			waterfall: ["3M"],
			watergun: ["3L1"],
			waterpulse: ["3M"],
			withdraw: ["3L1"],
		},
	},
	kabuto: {
		learnset: {
			absorb: ["3L13"],
			aerialace: ["3M"],
			ancientpower: ["3L55"],
			attract: ["3M"],
			aurorabeam: ["3E"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			bubblebeam: ["3E"],
			confuseray: ["3E"],
			dig: ["3M", "3E"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			endure: ["3T", "3L37"],
			facade: ["3M"],
			flail: ["3E"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			hail: ["3M"],
			harden: ["3L1"],
			hiddenpower: ["3M"],
			icebeam: ["3M"],
			knockoff: ["3E"],
			leer: ["3L19"],
			megadrain: ["3L49"],
			metalsound: ["3L43"],
			mimic: ["3T"],
			mudshot: ["3L25"],
			protect: ["3M"],
			raindance: ["3M"],
			rapidspin: ["3E"],
			rest: ["3M"],
			return: ["3M"],
			rockslide: ["3T"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandattack: ["3L31"],
			sandstorm: ["3M"],
			scratch: ["3L1"],
			secretpower: ["3M"],
			substitute: ["3T"],
			surf: ["3M"],
			thief: ["3M"],
			toxic: ["3M"],
			waterfall: ["3M"],
			waterpulse: ["3M"],
		},
	},
	kabutops: {
		learnset: {
			absorb: ["3L1"],
			aerialace: ["3M"],
			ancientpower: ["3L65"],
			attract: ["3M"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			cut: ["3M"],
			dig: ["3M"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			endure: ["3T", "3L37"],
			facade: ["3M"],
			frustration: ["3M"],
			furycutter: ["3T", "3L1"],
			gigadrain: ["3M"],
			hail: ["3M"],
			harden: ["3L1"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			leer: ["3L1"],
			megadrain: ["3L55"],
			megakick: ["3T"],
			metalsound: ["3L46"],
			mimic: ["3T"],
			mudshot: ["3L25"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rockslide: ["3T"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandattack: ["3L31"],
			sandstorm: ["3M"],
			scratch: ["3L1"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			slash: ["3L40"],
			substitute: ["3T"],
			surf: ["3M"],
			swordsdance: ["3T"],
			thief: ["3M"],
			toxic: ["3M"],
			waterfall: ["3M"],
			waterpulse: ["3M"],
		},
	},
	aerodactyl: {
		learnset: {
			aerialace: ["3M"],
			agility: ["3L8"],
			ancientpower: ["3L29"],
			attract: ["3M"],
			bite: ["3L15"],
			curse: ["3E"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dragonclaw: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			fly: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M", "3L50"],
			irontail: ["3M"],
			mimic: ["3T"],
			protect: ["3M"],
			pursuit: ["3E"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rockslide: ["3T"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandstorm: ["3M"],
			scaryface: ["3L36"],
			secretpower: ["3M"],
			steelwing: ["3M", "3E"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			supersonic: ["3L22"],
			takedown: ["3L43"],
			taunt: ["3M"],
			thief: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
			whirlwind: ["3E"],
			wingattack: ["3L1"],
		},
	},
	snorlax: {
		learnset: {
			amnesia: ["3L5"],
			attract: ["3M"],
			bellydrum: ["3L13"],
			blizzard: ["3M"],
			block: ["3L37"],
			bodyslam: ["3T", "3L33"],
			brickbreak: ["3M"],
			counter: ["3T"],
			covet: ["3L42"],
			curse: ["3E"],
			defensecurl: ["3T", "3L9"],
			doubleedge: ["3T", "3E"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			headbutt: ["3L17"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M", "3L51"],
			icebeam: ["3M"],
			lick: ["3E"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			protect: ["3M"],
			psychic: ["3M"],
			raindance: ["3M"],
			rest: ["3M", "3L25"],
			return: ["3M"],
			rockslide: ["3T"],
			rocktomb: ["3M"],
			rollout: ["3T", "3L46"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			sleeptalk: ["3T", "3L37"],
			snore: ["3T", "3L28"],
			solarbeam: ["3M"],
			strength: ["3M"],
			substitute: ["3T", "3E"],
			sunnyday: ["3M"],
			surf: ["3M"],
			tackle: ["3L1"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			toxic: ["3M"],
			waterpulse: ["3M"],
			yawn: ["3L21"],
		},
	},
	articuno: {
		learnset: {
			aerialace: ["3M"],
			agility: ["3L25"],
			blizzard: ["3M", "3L73"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			fly: ["3M"],
			frustration: ["3M"],
			gust: ["3L1"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M", "3L49"],
			mimic: ["3T"],
			mindreader: ["3L37"],
			mist: ["3L13"],
			powdersnow: ["3L1"],
			protect: ["3M"],
			raindance: ["3M"],
			reflect: ["3M", "3L61"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rocksmash: ["3M"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			sheercold: ["3L85"],
			steelwing: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			toxic: ["3M"],
			waterpulse: ["3M"],
		},
	},
	zapdos: {
		learnset: {
			aerialace: ["3M"],
			agility: ["3L25"],
			charge: ["3L61"],
			detect: ["3L37"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			drillpeck: ["3L49"],
			facade: ["3M"],
			flash: ["3M"],
			fly: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			lightscreen: ["3M", "3L73"],
			mimic: ["3T"],
			peck: ["3L1"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rocksmash: ["3M"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			shockwave: ["3M"],
			steelwing: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			thunder: ["3M", "3L85"],
			thunderbolt: ["3M"],
			thundershock: ["3L1"],
			thunderwave: ["3T", "3L13"],
			toxic: ["3M"],
		},
	},
	moltres: {
		learnset: {
			aerialace: ["3M"],
			agility: ["3L25"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			ember: ["3L1"],
			endure: ["3T", "3L37"],
			facade: ["3M"],
			fireblast: ["3M"],
			firespin: ["3L13"],
			flamethrower: ["3M", "3L49"],
			fly: ["3M"],
			frustration: ["3M"],
			heatwave: ["3L73"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			mimic: ["3T"],
			overheat: ["3M"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rocksmash: ["3M"],
			safeguard: ["3M", "3L61"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			skyattack: ["3T", "3L85"],
			steelwing: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			toxic: ["3M"],
			wingattack: ["3L1"],
		},
	},
	dratini: {
		learnset: {
			agility: ["3L36"],
			attract: ["3M"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dragondance: ["3E"],
			dragonrage: ["3L22"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			haze: ["3E"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M", "3L57"],
			icebeam: ["3M"],
			irontail: ["3M"],
			leer: ["3L1"],
			lightscreen: ["3E"],
			mimic: ["3T"],
			mist: ["3E"],
			outrage: ["3L50"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			safeguard: ["3M", "3L43"],
			secretpower: ["3M"],
			shockwave: ["3M"],
			slam: ["3L29"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			supersonic: ["3E"],
			surf: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			thunderwave: ["3T", "3L8"],
			toxic: ["3M"],
			twister: ["3L15"],
			waterfall: ["3M"],
			waterpulse: ["3M"],
			wrap: ["3L1"],
		},
	},
	dragonair: {
		learnset: {
			agility: ["3L38"],
			attract: ["3M"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dragonrage: ["3L22"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M", "3L65"],
			icebeam: ["3M"],
			irontail: ["3M"],
			leer: ["3L1"],
			mimic: ["3T"],
			outrage: ["3L56"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			safeguard: ["3M", "3L47"],
			secretpower: ["3M"],
			shockwave: ["3M"],
			slam: ["3L29"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			surf: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			thunderwave: ["3T", "3L1"],
			toxic: ["3M"],
			twister: ["3L1"],
			waterfall: ["3M"],
			waterpulse: ["3M"],
			wrap: ["3L1"],
		},
		encounters: [
			{generation: 3, level: 25, pokeball: "safariball"},
		],
	},
	dragonite: {
		learnset: {
			aerialace: ["3M"],
			agility: ["3L38"],
			attract: ["3M"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			cut: ["3M"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dragonclaw: ["3M"],
			dragonrage: ["3L22"],
			earthquake: ["3M"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			fly: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M", "3L75"],
			icebeam: ["3M"],
			irontail: ["3M"],
			leer: ["3L1"],
			mimic: ["3T"],
			outrage: ["3L61"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			safeguard: ["3M", "3L47"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			shockwave: ["3M"],
			slam: ["3L29"],
			steelwing: ["3M"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			surf: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			thunderwave: ["3T", "3L1"],
			toxic: ["3M"],
			twister: ["3L1"],
			waterfall: ["3M"],
			waterpulse: ["3M"],
			wingattack: ["3L55"],
			wrap: ["3L1"],
		},
	},
	mewtwo: {
		learnset: {
			aerialace: ["3M"],
			amnesia: ["3L77"],
			barrier: ["3L11"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			bulkup: ["3M"],
			calmmind: ["3M"],
			confusion: ["3L1"],
			counter: ["3T"],
			disable: ["3L1"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dreameater: ["3T"],
			earthquake: ["3M"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			futuresight: ["3L44"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			lightscreen: ["3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mist: ["3L22"],
			protect: ["3M"],
			psychic: ["3M", "3L66"],
			psychup: ["3T", "3L33"],
			raindance: ["3M"],
			recover: ["3L44"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			safeguard: ["3M", "3L55"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			skillswap: ["3M"],
			snatch: ["3M"],
			solarbeam: ["3M"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			swift: ["3T", "3L22"],
			taunt: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			thunderwave: ["3T"],
			torment: ["3M"],
			toxic: ["3M"],
			waterpulse: ["3M"],
		},
	},
	sentret: {
		learnset: {
			amnesia: ["3L49"],
			attract: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			cut: ["3M"],
			defensecurl: ["3T", "3L4"],
			dig: ["3M"],
			doubleedge: ["3T", "3E"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flamethrower: ["3M"],
			focusenergy: ["3E"],
			focuspunch: ["3M"],
			followme: ["3L31"],
			frustration: ["3M"],
			furyswipes: ["3L12"],
			helpinghand: ["3L17"],
			hiddenpower: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			mimic: ["3T"],
			protect: ["3M"],
			pursuit: ["3E"],
			quickattack: ["3L7"],
			raindance: ["3M"],
			rest: ["3M", "3L40"],
			return: ["3M"],
			scratch: ["3L1"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			slam: ["3L24"],
			slash: ["3E"],
			solarbeam: ["3M"],
			substitute: ["3T", "3E"],
			sunnyday: ["3M"],
			surf: ["3M"],
			thief: ["3M"],
			thunderbolt: ["3M"],
			toxic: ["3M"],
			waterpulse: ["3M"],
		},
	},
	furret: {
		learnset: {
			amnesia: ["3L59"],
			attract: ["3M"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			cut: ["3M"],
			defensecurl: ["3T", "3L1"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flamethrower: ["3M"],
			focuspunch: ["3M"],
			followme: ["3L37"],
			frustration: ["3M"],
			furyswipes: ["3L12"],
			helpinghand: ["3L19"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			mimic: ["3T"],
			protect: ["3M"],
			quickattack: ["3L1"],
			raindance: ["3M"],
			rest: ["3M", "3L48"],
			return: ["3M"],
			rocksmash: ["3M"],
			scratch: ["3L1"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			slam: ["3L28"],
			solarbeam: ["3M"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			surf: ["3M"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			toxic: ["3M"],
			waterpulse: ["3M"],
		},
	},
	ledyba: {
		learnset: {
			aerialace: ["3M"],
			agility: ["3L43"],
			attract: ["3M"],
			batonpass: ["3L29"],
			brickbreak: ["3M"],
			cometpunch: ["3L15"],
			dig: ["3M"],
			doubleedge: ["3T", "3L50"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			hiddenpower: ["3M"],
			lightscreen: ["3M", "3L22"],
			megapunch: ["3T"],
			mimic: ["3T"],
			protect: ["3M"],
			psybeam: ["3E"],
			reflect: ["3M", "3L22"],
			rest: ["3M"],
			return: ["3M"],
			safeguard: ["3M", "3L22"],
			secretpower: ["3M"],
			silverwind: ["3E"],
			solarbeam: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			supersonic: ["3L8"],
			swift: ["3T", "3L36"],
			swordsdance: ["3T"],
			tackle: ["3L1"],
			thief: ["3M"],
			toxic: ["3M"],
		},
	},
	ledian: {
		learnset: {
			aerialace: ["3M"],
			agility: ["3L51"],
			attract: ["3M"],
			batonpass: ["3L33"],
			brickbreak: ["3M"],
			cometpunch: ["3L15"],
			dig: ["3M"],
			doubleedge: ["3T", "3L60"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			lightscreen: ["3M", "3L24"],
			megapunch: ["3T"],
			mimic: ["3T"],
			protect: ["3M"],
			reflect: ["3M", "3L24"],
			rest: ["3M"],
			return: ["3M"],
			safeguard: ["3M", "3L24"],
			secretpower: ["3M"],
			solarbeam: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			supersonic: ["3L1"],
			swift: ["3T", "3L42"],
			swordsdance: ["3T"],
			tackle: ["3L1"],
			thief: ["3M"],
			toxic: ["3M"],
		},
	},
	spinarak: {
		learnset: {
			agility: ["3L45"],
			attract: ["3M"],
			batonpass: ["3E"],
			bodyslam: ["3T"],
			constrict: ["3L11"],
			dig: ["3M"],
			disable: ["3E"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			furyswipes: ["3L30"],
			gigadrain: ["3M"],
			hiddenpower: ["3M"],
			leechlife: ["3L23"],
			mimic: ["3T"],
			nightshade: ["3L17"],
			poisonsting: ["3L1"],
			protect: ["3M"],
			psybeam: ["3E"],
			psychic: ["3M", "3L53"],
			pursuit: ["3E"],
			rest: ["3M"],
			return: ["3M"],
			scaryface: ["3L6"],
			secretpower: ["3M"],
			sludgebomb: ["3M"],
			solarbeam: ["3M"],
			sonicboom: ["3E"],
			spiderweb: ["3L37"],
			stringshot: ["3L1"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			thief: ["3M"],
			toxic: ["3M"],
		},
	},
	ariados: {
		learnset: {
			agility: ["3L53"],
			attract: ["3M"],
			bodyslam: ["3T"],
			constrict: ["3L1"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			furyswipes: ["3L34"],
			gigadrain: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			leechlife: ["3L25"],
			mimic: ["3T"],
			nightshade: ["3L17"],
			poisonsting: ["3L1"],
			protect: ["3M"],
			psychic: ["3M", "3L63"],
			rest: ["3M"],
			return: ["3M"],
			scaryface: ["3L1"],
			secretpower: ["3M"],
			sludgebomb: ["3M"],
			solarbeam: ["3M"],
			spiderweb: ["3L43"],
			stringshot: ["3L1"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			thief: ["3M"],
			toxic: ["3M"],
		},
	},
	togepi: {
		learnset: {
			ancientpower: ["3L21"],
			attract: ["3M"],
			batonpass: ["3L41"],
			bodyslam: ["3T"],
			charm: ["3L1"],
			counter: ["3T"],
			doubleedge: ["3T", "3L37"],
			doubleteam: ["3M"],
			dreameater: ["3T"],
			encore: ["3L17"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			flash: ["3M"],
			followme: ["3L25"],
			frustration: ["3M"],
			futuresight: ["3E"],
			growl: ["3L1"],
			hiddenpower: ["3M"],
			lightscreen: ["3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T", "3L4"],
			mimic: ["3T"],
			mirrormove: ["3E"],
			peck: ["3E"],
			present: ["3E"],
			protect: ["3M"],
			psychic: ["3M"],
			raindance: ["3M"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			safeguard: ["3M", "3L33"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			softboiled: ["3T"],
			solarbeam: ["3M"],
			substitute: ["3T", "3E"],
			sunnyday: ["3M"],
			sweetkiss: ["3L9"],
			thunderwave: ["3T"],
			toxic: ["3M"],
			waterpulse: ["3M"],
			wish: ["3L29"],
			yawn: ["3L13"],
		},
	},
	togetic: {
		learnset: {
			aerialace: ["3M"],
			ancientpower: ["3L21"],
			attract: ["3M"],
			batonpass: ["3L41"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			charm: ["3L1"],
			counter: ["3T"],
			doubleedge: ["3T", "3L37"],
			doubleteam: ["3M"],
			dreameater: ["3T"],
			encore: ["3L17"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			flash: ["3M"],
			fly: ["3M"],
			focuspunch: ["3M"],
			followme: ["3L25"],
			frustration: ["3M"],
			growl: ["3L1"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			lightscreen: ["3M"],
			magicalleaf: ["3L1"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T", "3L1"],
			mimic: ["3T"],
			protect: ["3M"],
			psychic: ["3M"],
			raindance: ["3M"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			safeguard: ["3M", "3L33"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			softboiled: ["3T"],
			solarbeam: ["3M"],
			steelwing: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			sweetkiss: ["3L1"],
			thunderwave: ["3T"],
			toxic: ["3M"],
			waterpulse: ["3M"],
			wish: ["3L29"],
			yawn: ["3L13"],
		},
	},
	natu: {
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			calmmind: ["3M"],
			confuseray: ["3L40"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dreameater: ["3T"],
			drillpeck: ["3E"],
			facade: ["3M"],
			featherdance: ["3E"],
			feintattack: ["3E"],
			flash: ["3M"],
			frustration: ["3M"],
			futuresight: ["3L30"],
			gigadrain: ["3M"],
			haze: ["3E"],
			hiddenpower: ["3M"],
			leer: ["3L1"],
			lightscreen: ["3M"],
			mimic: ["3T"],
			nightshade: ["3L10"],
			peck: ["3L1"],
			protect: ["3M"],
			psychic: ["3M", "3L50"],
			quickattack: ["3E"],
			raindance: ["3M"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			skillswap: ["3M"],
			solarbeam: ["3M"],
			steelwing: ["3M", "3E"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			teleport: ["3L20"],
			thief: ["3M"],
			thunderwave: ["3T"],
			toxic: ["3M"],
			wish: ["3L30"],
		},
	},
	xatu: {
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			calmmind: ["3M"],
			confuseray: ["3L50"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dreameater: ["3T"],
			facade: ["3M"],
			flash: ["3M"],
			fly: ["3M"],
			frustration: ["3M"],
			futuresight: ["3L35"],
			gigadrain: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			leer: ["3L1"],
			lightscreen: ["3M"],
			mimic: ["3T"],
			nightshade: ["3L10"],
			peck: ["3L1"],
			protect: ["3M"],
			psychic: ["3M", "3L65"],
			raindance: ["3M"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			skillswap: ["3M"],
			solarbeam: ["3M"],
			steelwing: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			teleport: ["3L20"],
			thief: ["3M"],
			thunderwave: ["3T"],
			toxic: ["3M"],
			wish: ["3L35"],
		},
	},
	azurill: {
		learnset: {
			attract: ["3M"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			bubble: ["3L10"],
			charm: ["3L3"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			encore: ["3E"],
			facade: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			mimic: ["3T"],
			protect: ["3M"],
			raindance: ["3M"],
			refresh: ["3E"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			sing: ["3E"],
			slam: ["3L15", "3E"],
			splash: ["3L1"],
			substitute: ["3T"],
			surf: ["3M"],
			tailwhip: ["3L6"],
			tickle: ["3E"],
			toxic: ["3M"],
			waterfall: ["3M"],
			watergun: ["3L21"],
			waterpulse: ["3M"],
		},
	},
	marill: {
		learnset: {
			amnesia: ["3E"],
			attract: ["3M"],
			bellydrum: ["3E"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			bubblebeam: ["3L21"],
			defensecurl: ["3T", "3L3"],
			dig: ["3M"],
			dive: ["3M"],
			doubleedge: ["3T", "3L28"],
			doubleteam: ["3M"],
			facade: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hydropump: ["3L45"],
			icebeam: ["3M"],
			irontail: ["3M"],
			lightscreen: ["3E"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			perishsong: ["3E"],
			present: ["3E"],
			protect: ["3M"],
			raindance: ["3M", "3L36"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			rollout: ["3T", "3L15"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			strength: ["3M"],
			substitute: ["3T", "3E"],
			supersonic: ["3E"],
			surf: ["3M"],
			tackle: ["3L1"],
			tailwhip: ["3L6"],
			toxic: ["3M"],
			waterfall: ["3M"],
			watergun: ["3L10"],
			waterpulse: ["3M"],
		},
	},
	azumarill: {
		learnset: {
			attract: ["3M"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			bubblebeam: ["3L24"],
			defensecurl: ["3T", "3L1"],
			dig: ["3M"],
			dive: ["3M"],
			doubleedge: ["3T", "3L34"],
			doubleteam: ["3M"],
			facade: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hydropump: ["3L57"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			protect: ["3M"],
			raindance: ["3M", "3L45"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			rollout: ["3T", "3L15"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			strength: ["3M"],
			substitute: ["3T"],
			surf: ["3M"],
			tackle: ["3L1"],
			tailwhip: ["3L1"],
			toxic: ["3M"],
			waterfall: ["3M"],
			watergun: ["3L1"],
			waterpulse: ["3M"],
		},
	},
	hoppip: {
		learnset: {
			aerialace: ["3M"],
			amnesia: ["3E"],
			attract: ["3M"],
			bulletseed: ["3M"],
			confusion: ["3E"],
			cottonspore: ["3L25"],
			doubleedge: ["3T", "3E"],
			doubleteam: ["3M"],
			encore: ["3E"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			hiddenpower: ["3M"],
			leechseed: ["3L20"],
			megadrain: ["3L30"],
			mimic: ["3T"],
			poisonpowder: ["3L13"],
			protect: ["3M"],
			reflect: ["3E"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			sleeppowder: ["3L17"],
			solarbeam: ["3M"],
			splash: ["3L1"],
			stunspore: ["3L15"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			swordsdance: ["3T"],
			synthesis: ["3L5"],
			tackle: ["3L10"],
			tailwhip: ["3L5"],
			toxic: ["3M"],
		},
	},
	skiploom: {
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			bulletseed: ["3M"],
			cottonspore: ["3L29"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			hiddenpower: ["3M"],
			leechseed: ["3L22"],
			megadrain: ["3L36"],
			mimic: ["3T"],
			poisonpowder: ["3L13"],
			protect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			sleeppowder: ["3L17"],
			solarbeam: ["3M"],
			splash: ["3L1"],
			stunspore: ["3L15"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			swordsdance: ["3T"],
			synthesis: ["3L1"],
			tackle: ["3L1"],
			tailwhip: ["3L1"],
			toxic: ["3M"],
		},
	},
	jumpluff: {
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			bulletseed: ["3M"],
			cottonspore: ["3L33"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			leechseed: ["3L22"],
			megadrain: ["3L44"],
			mimic: ["3T"],
			poisonpowder: ["3L13"],
			protect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			sleeppowder: ["3L17"],
			solarbeam: ["3M"],
			splash: ["3L1"],
			stunspore: ["3L15"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			swordsdance: ["3T"],
			synthesis: ["3L1"],
			tackle: ["3L1"],
			tailwhip: ["3L1"],
			toxic: ["3M"],
		},
	},
	yanma: {
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			detect: ["3L25"],
			doubleedge: ["3T"],
			doubleteam: ["3M", "3L12"],
			dreameater: ["3T"],
			facade: ["3M"],
			flash: ["3M"],
			foresight: ["3L1"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			hiddenpower: ["3M"],
			hypnosis: ["3L23"],
			leechlife: ["3E"],
			mimic: ["3T"],
			protect: ["3M"],
			psychic: ["3M"],
			quickattack: ["3L6"],
			rest: ["3M"],
			return: ["3M"],
			reversal: ["3E"],
			screech: ["3L49"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			silverwind: ["3E"],
			solarbeam: ["3M"],
			sonicboom: ["3L17"],
			steelwing: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			supersonic: ["3L31"],
			tackle: ["3L1"],
			thief: ["3M"],
			toxic: ["3M"],
			uproar: ["3L34"],
			whirlwind: ["3E"],
			wingattack: ["3L39"],
		},
	},
	wooper: {
		learnset: {
			amnesia: ["3L21"],
			ancientpower: ["3E"],
			attract: ["3M"],
			blizzard: ["3M"],
			bodyslam: ["3T", "3E"],
			curse: ["3E"],
			dig: ["3M"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			earthquake: ["3M", "3L36"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			haze: ["3L51"],
			hiddenpower: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			mimic: ["3T"],
			mist: ["3L51"],
			mudshot: ["3L16"],
			protect: ["3M"],
			raindance: ["3M", "3L41"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			safeguard: ["3E"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			slam: ["3L11"],
			sludgebomb: ["3M"],
			spitup: ["3E"],
			stockpile: ["3E"],
			substitute: ["3T"],
			surf: ["3M"],
			swallow: ["3E"],
			tailwhip: ["3L1"],
			toxic: ["3M"],
			waterfall: ["3M"],
			watergun: ["3L1"],
			waterpulse: ["3M"],
			yawn: ["3L31"],
		},
	},
	quagsire: {
		learnset: {
			amnesia: ["3L23"],
			attract: ["3M"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			counter: ["3T"],
			dig: ["3M"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			earthquake: ["3M", "3L42"],
			facade: ["3M"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			haze: ["3L61"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mist: ["3L61"],
			mudshot: ["3L16"],
			protect: ["3M"],
			raindance: ["3M", "3L49"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			slam: ["3L11"],
			sludgebomb: ["3M"],
			strength: ["3M"],
			substitute: ["3T"],
			surf: ["3M"],
			tailwhip: ["3L1"],
			toxic: ["3M"],
			waterfall: ["3M"],
			watergun: ["3L1"],
			waterpulse: ["3M"],
			yawn: ["3L35"],
		},
	},
	murkrow: {
		learnset: {
			aerialace: ["3M"],
			astonish: ["3L9"],
			attract: ["3M"],
			calmmind: ["3M"],
			confuseray: ["3E"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dreameater: ["3T"],
			drillpeck: ["3E"],
			facade: ["3M"],
			featherdance: ["3E"],
			feintattack: ["3L35"],
			fly: ["3M"],
			frustration: ["3M"],
			haze: ["3L22"],
			hiddenpower: ["3M"],
			meanlook: ["3L48"],
			mimic: ["3T"],
			mirrormove: ["3E"],
			nightshade: ["3L27"],
			peck: ["3L1"],
			protect: ["3M"],
			pursuit: ["3L14"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			snatch: ["3M"],
			steelwing: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			taunt: ["3M", "3L40"],
			thief: ["3M"],
			thunderwave: ["3T"],
			torment: ["3M"],
			toxic: ["3M"],
			whirlwind: ["3E"],
			wingattack: ["3E"],
		},
	},
	misdreavus: {
		learnset: {
			aerialace: ["3M"],
			astonish: ["3L11"],
			attract: ["3M"],
			calmmind: ["3M"],
			confuseray: ["3L17"],
			destinybond: ["3E"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dreameater: ["3T"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			growl: ["3L1"],
			grudge: ["3L53"],
			hiddenpower: ["3M"],
			meanlook: ["3L23"],
			mimic: ["3T"],
			painsplit: ["3L37"],
			perishsong: ["3L45"],
			protect: ["3M"],
			psybeam: ["3L30"],
			psychic: ["3M"],
			psywave: ["3L1"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			screech: ["3E"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			skillswap: ["3M"],
			snatch: ["3M"],
			spite: ["3L6"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			taunt: ["3M"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			thunderwave: ["3T"],
			torment: ["3M"],
			toxic: ["3M"],
		},
	},
	unown: {
		learnset: {
			hiddenpower: ["3L1"],
		},
		encounters: [
			{generation: 3, level: 25},
		],
	},
	wynaut: {
		learnset: {
			charm: ["3L1"],
			counter: ["3L15"],
			destinybond: ["3L15"],
			encore: ["3L1"],
			mirrorcoat: ["3L15"],
			safeguard: ["3L15"],
			splash: ["3L1"],
		},
	},
	wobbuffet: {
		learnset: {
			counter: ["3L1"],
			destinybond: ["3L1"],
			mirrorcoat: ["3L1"],
			safeguard: ["3L1"],
		},
	},
	dunsparce: {
		learnset: {
			ancientpower: ["3E"],
			attract: ["3M"],
			bite: ["3E"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			calmmind: ["3M"],
			counter: ["3T"],
			curse: ["3E"],
			defensecurl: ["3T", "3L4"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dreameater: ["3T"],
			earthquake: ["3M"],
			endeavor: ["3L41"],
			facade: ["3M"],
			fireblast: ["3M"],
			flail: ["3L44"],
			flamethrower: ["3M"],
			frustration: ["3M"],
			glare: ["3L14"],
			headbutt: ["3E"],
			hiddenpower: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			mimic: ["3T"],
			protect: ["3M"],
			pursuit: ["3L24"],
			rage: ["3L1"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rockslide: ["3T", "3E"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			rollout: ["3T", "3L21"],
			screech: ["3L31"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			solarbeam: ["3M"],
			spite: ["3L21"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			takedown: ["3L34"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			thunderwave: ["3T"],
			toxic: ["3M"],
			waterpulse: ["3M"],
			yawn: ["3L11"],
		},
	},
	qwilfish: {
		learnset: {
			attract: ["3M"],
			blizzard: ["3M"],
			bubblebeam: ["3E"],
			destinybond: ["3L45"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flail: ["3E"],
			frustration: ["3M"],
			hail: ["3M"],
			harden: ["3L9"],
			haze: ["3E"],
			hiddenpower: ["3M"],
			hydropump: ["3L37"],
			icebeam: ["3M"],
			mimic: ["3T"],
			minimize: ["3L9"],
			pinmissile: ["3L21"],
			poisonsting: ["3L1"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			revenge: ["3L25"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			sludgebomb: ["3M"],
			spikes: ["3L1"],
			substitute: ["3T"],
			supersonic: ["3E"],
			surf: ["3M"],
			swordsdance: ["3T"],
			tackle: ["3L1"],
			takedown: ["3L33"],
			thunderwave: ["3T"],
			toxic: ["3M"],
			waterfall: ["3M"],
			watergun: ["3L13"],
			waterpulse: ["3M"],
		},
	},
	heracross: {
		learnset: {
			attract: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M", "3L23"],
			bulkup: ["3M"],
			counter: ["3T", "3L30"],
			cut: ["3M"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			endure: ["3T", "3L11"],
			facade: ["3M"],
			falseswipe: ["3E"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			furyattack: ["3L17"],
			harden: ["3E"],
			hiddenpower: ["3M"],
			hornattack: ["3L6"],
			hyperbeam: ["3M"],
			leer: ["3L1"],
			megahorn: ["3L53"],
			mimic: ["3T"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			reversal: ["3L45"],
			rockslide: ["3T"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			swordsdance: ["3T"],
			tackle: ["3L1"],
			takedown: ["3L37"],
			thief: ["3M"],
			toxic: ["3M"],
		},
	},
	sneasel: {
		learnset: {
			aerialace: ["3M"],
			agility: ["3L36"],
			attract: ["3M"],
			beatup: ["3L57"],
			bite: ["3E"],
			blizzard: ["3M"],
			brickbreak: ["3M"],
			calmmind: ["3M"],
			counter: ["3T", "3E"],
			cut: ["3M"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dreameater: ["3T"],
			facade: ["3M"],
			fakeout: ["3E"],
			feintattack: ["3L22"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			furyswipes: ["3L29"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			icebeam: ["3M"],
			icywind: ["3T", "3L43"],
			irontail: ["3M"],
			leer: ["3L1"],
			metalclaw: ["3L64"],
			mimic: ["3T"],
			protect: ["3M"],
			quickattack: ["3L8"],
			raindance: ["3M"],
			reflect: ["3E"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			scratch: ["3L1"],
			screech: ["3L15"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			slash: ["3L50"],
			snatch: ["3M"],
			spite: ["3E"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			surf: ["3M"],
			swordsdance: ["3T"],
			taunt: ["3M", "3L1"],
			thief: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
		},
	},
	slugma: {
		learnset: {
			acidarmor: ["3E"],
			amnesia: ["3L29"],
			attract: ["3M"],
			bodyslam: ["3T", "3L50"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			ember: ["3L8"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M", "3L36"],
			frustration: ["3M"],
			harden: ["3L22"],
			hiddenpower: ["3M"],
			lightscreen: ["3M"],
			mimic: ["3T"],
			overheat: ["3M"],
			protect: ["3M"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rockslide: ["3T", "3L43"],
			rocksmash: ["3M"],
			rockthrow: ["3L15"],
			secretpower: ["3M"],
			smog: ["3L1"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			toxic: ["3M"],
			yawn: ["3L1"],
		},
	},
	magcargo: {
		learnset: {
			amnesia: ["3L29"],
			attract: ["3M"],
			bodyslam: ["3T", "3L60"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			ember: ["3L1"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M", "3L36"],
			frustration: ["3M"],
			harden: ["3L22"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			lightscreen: ["3M"],
			mimic: ["3T"],
			overheat: ["3M"],
			protect: ["3M"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rockslide: ["3T", "3L48"],
			rocksmash: ["3M"],
			rockthrow: ["3L1"],
			rocktomb: ["3M"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			smog: ["3L1"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			toxic: ["3M"],
			yawn: ["3L1"],
		},
		encounters: [
			{generation: 3, level: 25},
		],
	},
	swinub: {
		learnset: {
			amnesia: ["3L55"],
			ancientpower: ["3E"],
			attract: ["3M"],
			bite: ["3E"],
			blizzard: ["3M", "3L46"],
			bodyslam: ["3T", "3E"],
			dig: ["3M"],
			doubleedge: ["3T", "3E"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			endure: ["3T", "3L19"],
			facade: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			icebeam: ["3M"],
			lightscreen: ["3M"],
			mimic: ["3T"],
			mist: ["3L37"],
			mudshot: ["3E"],
			odorsleuth: ["3L1"],
			powdersnow: ["3L10"],
			protect: ["3M"],
			raindance: ["3M"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rockslide: ["3T", "3E"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			strength: ["3M"],
			substitute: ["3T"],
			tackle: ["3L1"],
			takedown: ["3L28", "3E"],
			toxic: ["3M"],
		},
	},
	piloswine: {
		learnset: {
			amnesia: ["3L70"],
			attract: ["3M"],
			blizzard: ["3M", "3L56"],
			bodyslam: ["3T"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			endure: ["3T", "3L1"],
			facade: ["3M"],
			frustration: ["3M"],
			furyattack: ["3L33"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hornattack: ["3L1"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			lightscreen: ["3M"],
			mimic: ["3T"],
			mist: ["3L42"],
			odorsleuth: ["3L1"],
			powdersnow: ["3L1"],
			protect: ["3M"],
			raindance: ["3M"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rockslide: ["3T"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			strength: ["3M"],
			substitute: ["3T"],
			takedown: ["3L28"],
			toxic: ["3M"],
		},
	},
	remoraid: {
		learnset: {
			attract: ["3M"],
			aurorabeam: ["3L22", "3E"],
			blizzard: ["3M"],
			bubblebeam: ["3L22"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			focusenergy: ["3L33"],
			frustration: ["3M"],
			haze: ["3E"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M", "3L55"],
			icebeam: ["3M", "3L44"],
			lockon: ["3L11"],
			mimic: ["3T"],
			octazooka: ["3E"],
			protect: ["3M"],
			psybeam: ["3L22"],
			psychic: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			screech: ["3E"],
			secretpower: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			supersonic: ["3E"],
			surf: ["3M"],
			thief: ["3M"],
			thunderwave: ["3T", "3E"],
			toxic: ["3M"],
			waterfall: ["3M"],
			watergun: ["3L1"],
			waterpulse: ["3M"],
		},
	},
	octillery: {
		learnset: {
			attract: ["3M"],
			aurorabeam: ["3L22"],
			blizzard: ["3M"],
			bubblebeam: ["3L22"],
			bulletseed: ["3M"],
			constrict: ["3L11"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			focusenergy: ["3L38"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M", "3L70"],
			icebeam: ["3M", "3L54"],
			mimic: ["3T"],
			octazooka: ["3L25"],
			protect: ["3M"],
			psybeam: ["3L22"],
			psychic: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			sludgebomb: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			surf: ["3M"],
			thief: ["3M"],
			thunderwave: ["3T"],
			toxic: ["3M"],
			waterfall: ["3M"],
			watergun: ["3L1"],
			waterpulse: ["3M"],
		},
	},
	delibird: {
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			aurorabeam: ["3E"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			counter: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			fly: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			icebeam: ["3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			present: ["3L1"],
			protect: ["3M"],
			quickattack: ["3E"],
			raindance: ["3M"],
			rapidspin: ["3E"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			splash: ["3E"],
			substitute: ["3T"],
			thief: ["3M"],
			toxic: ["3M"],
			waterpulse: ["3M"],
		},
	},
	mantine: {
		learnset: {
			aerialace: ["3M"],
			agility: ["3L29"],
			attract: ["3M"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			bubble: ["3L1"],
			bubblebeam: ["3L15"],
			confuseray: ["3L50"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			haze: ["3E"],
			hiddenpower: ["3M"],
			hydropump: ["3E"],
			icebeam: ["3M"],
			mimic: ["3T"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rockslide: ["3E"],
			secretpower: ["3M"],
			slam: ["3E"],
			substitute: ["3T"],
			supersonic: ["3L8"],
			surf: ["3M"],
			tackle: ["3L1"],
			takedown: ["3L22"],
			toxic: ["3M"],
			twister: ["3E"],
			waterfall: ["3M"],
			waterpulse: ["3M", "3L43"],
			wingattack: ["3L36"],
		},
	},
	skarmory: {
		learnset: {
			aerialace: ["3M"],
			agility: ["3L16"],
			aircutter: ["3L29"],
			attract: ["3M"],
			counter: ["3T"],
			curse: ["3E"],
			cut: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			drillpeck: ["3E"],
			facade: ["3M"],
			fly: ["3M"],
			frustration: ["3M"],
			furyattack: ["3L26"],
			hiddenpower: ["3M"],
			leer: ["3L1"],
			metalsound: ["3L45"],
			mimic: ["3T"],
			peck: ["3L1"],
			protect: ["3M"],
			pursuit: ["3E"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rockslide: ["3T"],
			rocksmash: ["3M"],
			sandattack: ["3L10"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			spikes: ["3L42"],
			steelwing: ["3M", "3L32"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			swift: ["3T", "3L13"],
			taunt: ["3M"],
			thief: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
			whirlwind: ["3E"],
		},
	},
	phanpy: {
		learnset: {
			ancientpower: ["3E"],
			attract: ["3M"],
			bodyslam: ["3T", "3E"],
			counter: ["3T", "3E"],
			defensecurl: ["3T", "3L9"],
			doubleedge: ["3T", "3L49"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			endure: ["3T", "3L41"],
			facade: ["3M"],
			fissure: ["3E"],
			flail: ["3L17"],
			focusenergy: ["3E"],
			frustration: ["3M"],
			growl: ["3L1"],
			hiddenpower: ["3M"],
			irontail: ["3M"],
			mimic: ["3T"],
			odorsleuth: ["3L1"],
			protect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			rollout: ["3T", "3L33"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			tackle: ["3L1"],
			takedown: ["3L25"],
			toxic: ["3M"],
		},
	},
	donphan: {
		learnset: {
			attract: ["3M"],
			bodyslam: ["3T"],
			counter: ["3T"],
			defensecurl: ["3T", "3L9"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			earthquake: ["3M", "3L49"],
			facade: ["3M"],
			flail: ["3L17"],
			frustration: ["3M"],
			furyattack: ["3L25"],
			growl: ["3L1"],
			hiddenpower: ["3M"],
			hornattack: ["3L1"],
			hyperbeam: ["3M"],
			irontail: ["3M"],
			mimic: ["3T"],
			odorsleuth: ["3L1"],
			protect: ["3M"],
			rapidspin: ["3L41"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rockslide: ["3T"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			rollout: ["3T", "3L33"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			toxic: ["3M"],
		},
	},
	raikou: {
		learnset: {
			bite: ["3L1"],
			bodyslam: ["3T"],
			calmmind: ["3M", "3L81"],
			crunch: ["3L61"],
			cut: ["3M"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			irontail: ["3M"],
			leer: ["3L1"],
			mimic: ["3T"],
			protect: ["3M"],
			quickattack: ["3L31"],
			raindance: ["3M"],
			reflect: ["3M", "3L51"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M", "3L21"],
			rocksmash: ["3M"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			shockwave: ["3M"],
			spark: ["3L41"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			thunder: ["3M", "3L71"],
			thunderbolt: ["3M"],
			thundershock: ["3L11"],
			thunderwave: ["3T"],
			toxic: ["3M"],
		},
		encounters: [
			{generation: 3, level: 40},
		],
	},
	entei: {
		learnset: {
			bite: ["3L1"],
			bodyslam: ["3T"],
			calmmind: ["3M", "3L81"],
			cut: ["3M"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			ember: ["3L11"],
			facade: ["3M"],
			fireblast: ["3M", "3L71"],
			firespin: ["3L31"],
			flamethrower: ["3M", "3L51"],
			flash: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			irontail: ["3M"],
			leer: ["3L1"],
			mimic: ["3T"],
			protect: ["3M"],
			raindance: ["3M"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M", "3L21"],
			rocksmash: ["3M"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			solarbeam: ["3M"],
			stomp: ["3L41"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			swagger: ["3T", "3L61"],
			toxic: ["3M"],
		},
		encounters: [
			{generation: 3, level: 40},
		],
	},
	suicune: {
		learnset: {
			aurorabeam: ["3L41"],
			bite: ["3L1"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			bubblebeam: ["3L11"],
			calmmind: ["3M", "3L81"],
			cut: ["3M"],
			dig: ["3M"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			facade: ["3M"],
			frustration: ["3M"],
			gust: ["3L31"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hydropump: ["3L71"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			leer: ["3L1"],
			mimic: ["3T"],
			mirrorcoat: ["3L61"],
			mist: ["3L51"],
			protect: ["3M"],
			raindance: ["3M", "3L21"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rocksmash: ["3M"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			surf: ["3M"],
			toxic: ["3M"],
			waterfall: ["3M"],
			waterpulse: ["3M"],
		},
		encounters: [
			{generation: 3, level: 40},
		],
	},
	larvitar: {
		learnset: {
			attract: ["3M"],
			bite: ["3L1"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			crunch: ["3L43"],
			curse: ["3E"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dragondance: ["3E"],
			earthquake: ["3M", "3L50"],
			facade: ["3M"],
			focusenergy: ["3E"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M", "3L57"],
			leer: ["3L1"],
			mimic: ["3T"],
			outrage: ["3E"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rockslide: ["3T", "3L22"],
			rocksmash: ["3M"],
			sandstorm: ["3M", "3L8"],
			scaryface: ["3L36"],
			screech: ["3L15"],
			secretpower: ["3M"],
			stomp: ["3E"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			taunt: ["3M"],
			thrash: ["3L29"],
			torment: ["3M"],
			toxic: ["3M"],
		},
	},
	pupitar: {
		learnset: {
			attract: ["3M"],
			bite: ["3L1"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			crunch: ["3L47"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			earthquake: ["3M", "3L56"],
			facade: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M", "3L65"],
			leer: ["3L1"],
			mimic: ["3T"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rockslide: ["3T", "3L22"],
			rocksmash: ["3M"],
			sandstorm: ["3M", "3L1"],
			scaryface: ["3L38"],
			screech: ["3L1"],
			secretpower: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			taunt: ["3M"],
			thrash: ["3L29"],
			torment: ["3M"],
			toxic: ["3M"],
		},
	},
	tyranitar: {
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			bite: ["3L1"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			counter: ["3T"],
			crunch: ["3L47"],
			cut: ["3M"],
			dig: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dragonclaw: ["3M"],
			earthquake: ["3M", "3L61"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M", "3L75"],
			icebeam: ["3M"],
			irontail: ["3M"],
			leer: ["3L1"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rockslide: ["3T", "3L22"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandstorm: ["3M", "3L1"],
			scaryface: ["3L38"],
			screech: ["3L1"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			shockwave: ["3M"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			surf: ["3M"],
			taunt: ["3M"],
			thrash: ["3L29"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			thunderwave: ["3T"],
			torment: ["3M"],
			toxic: ["3M"],
			waterpulse: ["3M"],
		},
	},
	lugia: {
		learnset: {
			aerialace: ["3M"],
			aeroblast: ["3L77"],
			ancientpower: ["3L88"],
			blizzard: ["3M"],
			bodyslam: ["3T"],
			calmmind: ["3M"],
			dive: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dreameater: ["3T"],
			earthquake: ["3M"],
			facade: ["3M"],
			fly: ["3M"],
			frustration: ["3M"],
			futuresight: ["3L99"],
			gigadrain: ["3M"],
			gust: ["3L22"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hydropump: ["3L44"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			lightscreen: ["3M"],
			mimic: ["3T"],
			protect: ["3M"],
			psychic: ["3M"],
			raindance: ["3M", "3L55"],
			recover: ["3L33"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rocksmash: ["3M"],
			safeguard: ["3M", "3L11"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			skillswap: ["3M"],
			steelwing: ["3M"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			surf: ["3M"],
			swift: ["3T", "3L66"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			thunderwave: ["3T"],
			toxic: ["3M"],
			waterfall: ["3M"],
			waterpulse: ["3M"],
			whirlwind: ["3L1"],
		},
	},
	hooh: {
		learnset: {
			aerialace: ["3M"],
			ancientpower: ["3L88"],
			calmmind: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M"],
			dreameater: ["3T"],
			earthquake: ["3M"],
			facade: ["3M"],
			fireblast: ["3M", "3L44"],
			flamethrower: ["3M"],
			flash: ["3M"],
			fly: ["3M"],
			frustration: ["3M"],
			futuresight: ["3L99"],
			gigadrain: ["3M"],
			gust: ["3L22"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			lightscreen: ["3M"],
			mimic: ["3T"],
			overheat: ["3M"],
			protect: ["3M"],
			psychic: ["3M"],
			raindance: ["3M"],
			recover: ["3L33"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rocksmash: ["3M"],
			sacredfire: ["3L77"],
			safeguard: ["3M", "3L11"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			solarbeam: ["3M"],
			steelwing: ["3M"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M", "3L55"],
			swift: ["3T", "3L66"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			thunderwave: ["3T"],
			toxic: ["3M"],
			whirlwind: ["3L1"],
		},
	},
	deoxysattack: {
		learnset: {
			aerialace: ["3M"],
			agility: ["3L35"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			calmmind: ["3M"],
			cosmicpower: ["3L35"],
			counter: ["3T"],
			cut: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M", "3L10"],
			dreameater: ["3T"],
			facade: ["3M"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3L50", "3M"],
			icebeam: ["3M"],
			leer: ["3L1"],
			lightscreen: ["3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			nightshade: ["3L5"],
			protect: ["3M"],
			psychic: ["3M", "3L25"],
			psychoboost: ["3L45"],
			pursuit: ["3L20"],
			raindance: ["3M"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rockslide: ["3T"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			safeguard: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			skillswap: ["3M"],
			snatch: ["3M"],
			solarbeam: ["3M"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			superpower: ["3L30"],
			taunt: ["3L15", "3M"],
			teleport: ["3L10"],
			thunderbolt: ["3M"],
			thunderwave: ["3T"],
			torment: ["3M"],
			toxic: ["3M"],
			waterpulse: ["3M"],
			wrap: ["3L1"],
			zapcannon: ["3L40"],
		},
	},
	deoxysdefense: {
		learnset: {
			aerialace: ["3M"],
			agility: ["3L35"],
			amnesia: ["3L35"],
			bodyslam: ["3T"],
			brickbreak: ["3M"],
			calmmind: ["3M"],
			counter: ["3T", "3L50"],
			cut: ["3M"],
			doubleedge: ["3T"],
			doubleteam: ["3M", "3L10"],
			dreameater: ["3T"],
			facade: ["3M"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			irondefense: ["3L35"],
			knockoff: ["3L15"],
			leer: ["3L1"],
			lightscreen: ["3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mirrorcoat: ["3L50"],
			nightshade: ["3L5"],
			protect: ["3M"],
			psychic: ["3M", "3L25"],
			psychoboost: ["3L45"],
			raindance: ["3M"],
			recover: ["3L40"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rockslide: ["3T"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			safeguard: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3T"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			skillswap: ["3M"],
			snatch: ["3L30", "3M"],
			solarbeam: ["3M"],
			spikes: ["3L20"],
			strength: ["3M"],
			substitute: ["3T"],
			sunnyday: ["3M"],
			taunt: ["3M"],
			teleport: ["3L10"],
			thunderbolt: ["3M"],
			thunderwave: ["3T"],
			torment: ["3M"],
			toxic: ["3M"],
			waterpulse: ["3M"],
			wrap: ["3L1"],
		},
	},
};